/* ============================================================================
   BKS — KIT DECO ASSORTI (vente complementaire couleur-assortie)
   ----------------------------------------------------------------------------
   OBJECTIF (demande proprietaire) : proposer le kit deco en COMPLEMENT de la
   housse de selle, assorti a la couleur choisie par le client — sur le meme
   principe que la mousse de guidon assortie, mais present PARTOUT (page panier,
   tiroir panier), pas seulement dans le configurateur 2D.

   PRINCIPE
   --------
   1) On lit le panier (/cart.js) et on cherche la ligne de la selle (_bks_role='base').
   2) On en extrait la COULEUR DU DESSUS. Les trois configurateurs ne nomment pas
      leurs proprietes pareil :
        - FUSION            : "Dessus" = "Violet · Simili cuir"
        - configurateur 2D  : proprietes variables
        - LA BKS (v2)       : "Descriptif" / "Matieres"
      => on balaie les proprietes par ordre de priorite et on reconnait le premier
         nom de couleur de la palette BKS. Tolerant aux accents et a la casse.
   3) On resout le kit deco assorti, DANS CET ORDRE :
        a. le kit COULEUR UNIE exacte  (ex. selle violette -> kit violet) ;
        b. a defaut, le kit BI-COLORE contenant cette couleur (ex. violette -> Turquoise/Violet) ;
        c. sinon : on n'affiche RIEN. Jamais de fausse offre.
      La resolution se fait en direct via /products/<handle>.js : un produit
      depublie renvoie 404 et disparait tout seul de l'offre. Aucun prix, aucun
      identifiant de variante n'est code en dur : tout vient du catalogue en live.
      => le jour ou les references couleur-unie sont republiees, l'assortiment
         exact reprend automatiquement, sans toucher a ce fichier.
   4) L'encart s'affiche dans la page panier et dans le tiroir. Un clic ajoute le
      kit. La ligne porte _bks_kitdeco='1' et PAS de _bks_id : elle reste donc
      detachable et bks-cart-guard.js l'ignore (ce n'est pas une piece du lot).
   5) Le kit compte dans le total qualifiant : l'ajouter rapproche des paliers
      cadeaux, et bks-gift-sync.js recalcule tout seul juste apres.

   NON NEGOCIABLE : opt-in. Rien n'est ajoute sans un clic explicite du client
   (art. 22 de la directive 2011/83/UE : aucune option payante pre-cochee).
   Si le client ferme l'encart, on ne le lui repropose plus de la session.
   ============================================================================ */
(function () {
  "use strict";
  try { if (window.__bksKitDeco) return; window.__bksKitDeco = 1; } catch (e) { return; }

  /* ⚠️ CE FICHIER EST UNE COPIE CORRIGÉE de assets/bks-kitdeco-assorti.js (01/10 12:57), qui n'a PAS de propriétaire dans
     site/proprietaires.json. Il est chargé AVANT l'original par snippets/bks-aa-autre-modele-pont.liquid (rendu par
     sections/footer.liquid) et pose le même verrou window.__bksKitDeco : l'original, chargé plus bas par
     layout/theme.liquid, s'arrête alors à sa 1re ligne. C'est un PONT, en attendant que l'orchestrateur attribue
     l'original : on y recopiera ce fichier, puis on retirera la ligne du pont (procédure : site/rapports/0110v2-fusion-autre.md).
     Toute retouche du kit déco assorti se fait donc ICI tant que le pont est en place.
     01/10/2026 soir (lot fusion-autre v2) :
     la puce « Autre modèle » du sélecteur de moto laissait ajouter le kit avec « Derbi — autre modèle » : ni le modèle,
     ni l'année — l'atelier ne sait pas quel kit découper (SAV). Désormais, quand « Autre modèle » est choisi, deux champs
     OBLIGATOIRES (« Modèle exact », « Année ») remplacent la bande des années, et « Ajouter à ma commande » est bloqué tant
     qu'ils ne sont pas valides — MÊME RÈGLE, mot pour mot, que le configurateur FUSION et les fiches (bloc ci-dessous,
     copie conforme contrôlée par site/outils/0110v2/fusion-autre/G3-banc-regle.js). Le sélecteur reste FACULTATIF :
     sans marque choisie, ou avec un modèle de la liste, rien ne change. */
/* <bks-regle-modele v6> ================================================================================
   BKS · lot fusion-autre (01/10/2026 soir ; v4 le 02/10 ; v5 et v6 le 05/10) — LA RÈGLE « MARQUE + MODÈLE » ET « ANNÉE ».
   Bloc IDENTIQUE, octet pour octet, dans assets/bks-fusion.js (configurateur FUSION, « Autre 50cc… »),
   assets/bks-aa-autre-modele.js (fiches produit) et assets/bks-aa-autre-modele-kitdeco.js (kit déco assorti du
   panier et du tiroir) : le banc site/outils/0210/fusion-autre/t1c/K3-banc-regle.js refuse deux copies différentes
   et rejoue les listes de TOUS les vérificateurs.

   POURQUOI UNE RÈGLE POSITIVE. Une liste noire de non-réponses ne finit jamais (« j'ai oublié », « blorf kwip »…).
   On exige ce qui FAIT une moto : une MARQUE reconnue (liste large des constructeurs de 50cc / 125cc, fautes
   d'écriture comprises) OU un MODÈLE reconnu, PLUS au moins un autre élément qui dit quelque chose (le modèle, un
   code comme « RS3 » ou « XP6 », un nombre de modèle comme « 103 » ou « 125 »). Le reste est refusé, avec un
   message qui dit quoi écrire.

   v3 (01/10 soir) — un mot inconnu ne compte comme modèle que s'il TOUCHE une marque, un modèle ou un code
   (« Peugeot je vais vérifier » refusé) ; RIEN apprend verbes, adverbes, interjections ; nombres et suites.

   v4 (02/10) — CE QUE LE VÉRIFICATEUR DU 02/10 A FAIT PASSER, ET POURQUOI C'EST FERMÉ. En v3, une marque connue + UN
   mot inconnu collé passait en un clic : « Peugeot jsaispas », « MBK chépas », « Honda balec », « Yamaha random »,
   « Peugeot idées », « Peugeot inconue »… (22 non-réponses nettes sur 69 neuves, et 25 sur 40 d'un témoin écrit
   AVANT la v4) — c'est la façon d'écrire d'un acheteur de 50cc. Trois verrous :
   (a) RIEN reconnaît les formes FLÉCHIES et les fautes d'une lettre de ses mots : pluriel et féminin (idées -> idée,
       ignorée -> ignore, pareille -> pareil), et une lettre de plus / de moins / changée sur un mot de RIEN de 6
       lettres ou plus (inconue -> inconnue) — jamais pour un mot qui est un modèle connu (à 5 lettres, « cross »
       devenait « crois » : mesuré sur les noms réels, K2-corpus.js) ;
   (b) RIEN apprend l'argot des non-réponses (jsaispas, chépas, osef, balec, tkt, kesako, random, whatever, mystère…) ;
   (c) le cas STRUCTUREL est fermé plutôt que la liste allongée à l'infini : quand l'acceptation ne repose QUE sur
       « marque + mot(s) inconnu(s) » (aucun code, aucun nombre de modèle, aucun modèle connu), la raison est
       'douteux'. L'interface ne l'accepte qu'après une case EXPLICITE, non cochée par défaut (« Oui, « … » est bien
       le nom exact de ma moto »), transmise à l'atelier. « Fantic Caballero » passe toujours (Caballero est connu) ;
       « Yamaha enduro » passe avec la case ; « Peugeot jsaispas » est refusé net.
   Et des vraies motos refusées à tort sont rouvertes : Mobylette est une marque (et un modèle juste après
   Motobécane / MBK), « Bleue » est un modèle juste après Motobécane, Barton / Senke / Solex / Junak / Zipp…
   ajoutées, un code de 4 chiffres qui touche une marque est un modèle (« Solex 3800 »), « Sport » n'est plus un
   mot vide (« Senke Sport 50 », avec la case). Un nombre de 2 chiffres hors liste (« Peugeot 42 ») ne suffit plus
   seul : 'douteux'.
   - Marque connue + modèle connu, code ou nombre de modèle : accepté (« Rieju RS3 50 », « Derbi Senda DRD »).
   - Marque connue + seulement un ou des mots inconnus (ou un nombre de 2 chiffres) : 'douteux' (case à cocher).
   - Modèle connu + un autre élément : accepté (« XPS Street », « Senda DRD »). Modèle seul : on demande la marque.
   - Marque ABSENTE de la liste : acceptée si un mot TOUCHE un code ou un nombre de modèle (« Lexmoto ZSB 125 »,
     « Orbit RX7 ») — une vraie moto n'est pas refusée parce que sa marque manque ici.
   - Une faute d'UNE lettre sur une marque de 5 lettres ou plus compte comme la marque (« Huskvarna », « Yamhaa »).
   - Un nombre seul n'est un modèle qu'en 3 chiffres (« 103 », « 125 ») ou en 4 chiffres collé à une marque
     (« Solex 3800 ») ; « 1234 », « 123 », « abc123 » (suites) ne disent rien. « 50 », « 50cc » non plus (tout est
     50cc ici) ; une année (19xx / 20xx) a son propre champ.
   v5 (05/10) — L'HÉSITATION. Un témoin neuf passé EN LIGNE (E10-temoin-0510.js) a fait passer en un clic
   « Derbi Senda je crois » ; la sonde E10b a suivi : dès qu'une marque ET un modèle connus sont là, TOUT le reste était
   ignoré — « Peugeot XR6 ou XPS » (deux motos), « Derbi Senda jsp », « … je sais plus », « … pas sûr », « … ? ». Une
   saisie qui dit elle-même qu'elle n'est pas sûre ne donne pas les mesures. Désormais, une saisie qui SERAIT acceptée
   ('' ou 'douteux') mais qui porte une hésitation — un « ? », le mot « ou », « je crois / je pense / il me semble /
   peut-être / normalement / a priori / genre… », « je sais pas / plus », « pas sûr / pas certain », l'argot du « je sais
   pas » — rend 'hesite' : refusé, avec un message qui dit d'écrire UN seul modèle. Rien ne change pour une saisie déjà
   refusée (« Yamaha je pense » reste « Ajoute le modèle après la marque »).
   v6 (05/10 soir) — CE QUE LE VÉRIFICATEUR DU 05/10 A FAIT PASSER EN UN CLIC (vrais paniers à l'appui), ET POURQUOI C'EST
   FERMÉ :
   (1) « MARQUE + CYLINDRÉE » (« Honda 125 », « KTM 250 », « Husqvarna 250 » — la façon la plus courante de décrire sa
       moto, surtout sur les fiches supermotard) : un nombre de 3 chiffres comptait comme un code de modèle. Les
       CYLINDRÉES (liste CYL, « 125cc », « 80cc », « 250 cm3 », « 125R » compris) sont retirées AVANT de classer les mots :
       ni modèle, ni code, ni voisin d'un mot inconnu. « Honda 125 » -> « Ajoute le modèle après la marque » ; « Yamaha DT
       125 », « KTM EXC 125 », « Lexmoto ZSB 125 », « Peugeot 103 », « Solex 3800 » passent toujours.
   (2) « CATÉGORIE + CYLINDRÉE » sans marque (« Cross 125 », « Enduro 125 », « Trucmuche 125 ») : fermé par (1) ; et les
       CATÉGORIES (GENRE : cross, enduro, motard, trail…) ne sont un nom de modèle que JUSTE APRÈS une marque, et alors
       avec la case (« Beta Motard », « Derbi Cross City », « Yamaha cross 125 ») ; ailleurs elles ne disent rien
       (« Cross SX » -> on demande la marque). « motocross », « dirtbike », « supermoto » : mots vides.
   (3) DEUX MOTOS sans « ou » (« Peugeot XR6 / XPS », « … et XPS », « …, XPS », « MBK X-Limit + Yamaha DT ») : la saisie
       est coupée aux séparateurs ; deux morceaux qui nomment chacun quelque chose = deux motos -> 'hesite'. Aussi deux
       marques portant chacune un modèle (« Peugeot XR6 Peugeot XPS »), sauf la marque d'un moteur (« moteur Derbi »).
   (4) L'HÉSITATION était une liste noire à trous (« sûrement », « sans doute », « à vérifier », « apparemment »,
       « jsais pas », « je dirais »…) : liste élargie par FAMILLES (doute, probabilité, « à vérifier / plus tard »,
       « je sais pas » et ses formes, copie / ressemblance), une faute d'une lettre sur un mot de 7 lettres ou plus,
       la négation à deux mots près (« pas trop sûr », « non vérifié », « aucune idée »), et les signes « ? ¿ ~ ± 🤔 ».
       Un banc de PROPRIÉTÉS vérifie qu'un mot d'hésitation ajouté à n'importe quel nom réel donne 'hesite', et
       qu'aucun nom réel seul ne le donne.
   AJOUTER UNE MARQUE : l'écrire dans MARQUES (minuscules, sans accent, sans tiret) ; en deux mots : aussi dans
   DEUX_MOTS. UN MODÈLE qui est aussi un mot courant (Vogue, Fox, Club…) : dans APRES (il ne compte que juste après
   une marque). Puis lancer K5-integrer-regle.js (il recopie le bloc dans les trois fichiers) et K3-banc-regle.js.
   Année : 4 chiffres, de 1985 à l'année en cours + 1 (les millésimes sortent l'année d'avant).
   ======================================================================================================= */
var BKS_REGLE = (function () {
  var AN_MIN = 1985, AN_MAX = new Date().getFullYear() + 1;
  function dico(t) { var o = {}; t.split(' ').forEach(function (w) { if (w) o[w] = 1; }); return o; }
  /* constructeurs de 50cc / 125cc (et leurs fautes d'écriture courantes) */
  var MARQUES = dico(
    'aprilia aprillia aprilla beta cpi derbi derby fantic fantik generic generique gilera gillera honda masai massai'
    + ' husqvarna husquarna husky peugeot peugot peugeut pegeot rieju riejou sherco scherco vent yamaha mbk'
    + ' piaggio piagio vespa ktm kawasaki kawa kawazaki gasgas gas suzuki susuki malaguti malagutti keeway keway'
    + ' sym kymco kimco tm mash bultaco italjet hm motobecane motobecanne motoconfort tomos puch simson kreidler'
    + ' zundapp hercules sachs garelli gitane cagiva montesa ossa benelli mondial swm zontes voge cfmoto qjmotor'
    + ' lifan loncin zongshen jinlun baotian znen jiajue qingqi hanway orcal skyteam bluroc brixton mutt herald'
    + ' bullit archive ajp macbor motron daelim hyosung adly tgb pgo aeon eton kayo apollo ycf bastos surron'
    + ' talaria supersoco polini yamasaki neco rex motorhispania mh lambretta mvagusta lexmoto sinnis wk'
    + ' govecs nipponia ducati triumph bmw'
    /* v3 : marques réelles absentes de la v2 (vraies motos refusées par le vérificateur t1) */
    + ' romet tauris kinroad ksr pitster bucci daytona thumpstar stomp ssr jincheng jonway beeline luxxon'
    + ' leonart motobi fym lml benzhou emco unu niu askoll horwin rfz wpb lem orion'
    /* v4 : marques réelles refusées par le vérificateur du 02/10 (Mobylette = la marque de Motobécane) */
    + ' mobylette barton senke solex velosolex junak zipp motorro');
  var DEUX_MOTS = [['gas gas', 'gasgas'], ['cf moto', 'cfmoto'], ['qj motor', 'qjmotor'], ['mv agusta', 'mvagusta'],
    ['sur ron', 'surron'], ['super soco', 'supersoco'], ['motor hispania', 'motorhispania'], ['moto becane', 'motobecane'],
    ['velo solex', 'velosolex'], ['x limit', 'xlimit'], ['x race', 'xrace'], ['x treme', 'xtreme'], ['x power', 'xpower'],
    ['e ton', 'eton'], ['aujourd hui', 'aujourdhui'], ['peut etre', 'peutetre']];
  /* modèles de 50cc / 125cc reconnus SANS leur marque (2 lettres au moins ; jamais un mot courant du français) */
  var MODELES = dico(
    'xps xp6 xp7 xr6 xr7 xp xr xrace xtreme xtrem xpower senda drd smt rcr sx rx mx rs rs2 rs3 rs4 rs50 rs125 tuono'
    + ' mrt mrx smx rrx rr spike tango marathon drac dt dtr dtx dtmx tzr tdr xlimit booster nitro stunt aerox ovetto'
    + ' zip typhoon runner ludix speedfight kisbee vivacity trekker buxy zenith ciao trigger cre baja crf cr msx monkey'
    + ' dax rm rmx kx tc tx wr yz exc smr ser mc ec xe xm caballero fifty furious mulhacen gpr florett sm sp spx rcx'
    + ' 103 51 41 88'
    /* v4 : modèles réels sans ambiguïté (aucun n'est un mot courant) */
    + ' elyseo elystar satelis geopolis looxor squab citystar belville metropolis tkr streetzone django jetforce'
    + ' skyliner doodo evolis cygnus majesty xmax tmax camino wallaroo zoomer ruckus pcx mbx nsr cbr scarabeo amico'
    + ' atlantis stalker agility dink vitality fiddle symply crox hurricane xray hrd madison ciak xtm streetmate'
    + ' flexer targa mobyx mobymatic schwalbe aragon hussar gtr derapage xor chappy katia streaker astor ark eikon'
    + ' quadra mio brinco dragster lobito xplorer ryz'
    /* v6 : modèles de 125 que la règle ne voyait que par leur cylindrée (« Yamaha YBR 125 », « KTM 125 Duke ») */
    + ' ybr yzf duke varadero innova grom'
    /* v6 : modèles qui sont un nombre de 3 chiffres (Peugeot 101-105, Solex 330 / 660, Junak 901, Benelli 491) */
    + ' 101 102 104 105 330 660 901 491');
  /* v4 : modèles RÉELS qui sont aussi des mots courants : ils ne comptent comme modèle que JUSTE APRÈS une marque
     (« Peugeot Vogue », « MBK Club » oui ; « club de foot » non) */
  var APRES = dico(
    'vogue fox rapido chrono club spirit flipper magnum forte swing evasion slider jog liberty bravo boxer sonic rally'
    + ' predator hunter terra variant boulevard storm ice easy people like super vision today why fly focus matrix'
    + ' phantom grizzly yesterday revival sprint cady maxi cobra eureka prima popcorn oliver furia hyper raw cafe neo'
    + ' neos rocket ultimate jet orbit monster pony rider');
  /* les mots qui ne disent RIEN de la moto (ils ne comptent pas comme « autre élément ») */
  var RIEN = dico(
    'autre autres a au aux ce ces cet cette c ca d de des du en et est etait il elle ils elles j je l la le les leur lui m ma me mes'
    + ' moi mon n ne nous on ou par pas pour qu que qui quoi s sa se ses si son sur t ta te tes toi ton tu un une vous'
    + ' votre vos y avec chez dans sans sous vers depuis entre plus moins tres trop peu bien mal aussi encore deja ai as'
    + ' sais sait savoir sai connais connait connaitre ignore crois croit pense pensais suppose sure certain certaine'
    + ' exactement exact environ peut etre peutetre probablement surement doute rappelle souviens souvenir oublie'
    + ' oubliee oublier verifie verifier verif confirmer confirme regarde regarder reviens revenir complete completer'
    + ' preciser precise apres demain tard bientot attente attendre attends verra verrai voir vu vois cf ci joint jointe'
    + ' piece appel appelle appelez appeler rappel rappeler telephone tel numero mail email sms whatsapp insta instagram'
    + ' facebook fb messenger message msg contact contacte contactez contacter envoie envoyer envoi envoye photo photos'
    + ' image lien dis dit dire dirai demande demander'
    + ' non nan nope no none oui ok okay aucune aucun rien inconnu inconnue nc na nr nsp jsp jsais chais chai chepa'
    + ' chaispas jesaispas saispas idk idee name noname nom test essai nimporte importe quel quelle quelconque truc'
    + ' machin chose bidule bla blabla ras neant vide pareil meme idem similaire comme style genre type sorte standard'
    + ' normal normale classique basique simple universel universelle toutes tous tout toute modele modeles model'
    + ' marque marques annee version origine originale definir precedent precedente renseigne commande derniere dernier'
    + ' pere mere papa maman fils fille frere soeur cousin cousine oncle tonton tante grand pote potes copain copine'
    + ' ami amie voisin voisine garage garagiste concession concessionnaire mecano atelier magasin parent parents famille'
    + ' bonjour bonsoir salut hello merci svp stp lol mdr ptdr world bks micka mickael mika bikesellier housse housses'
    + ' selle selles siege moto motos mob cyclo cyclomoteur scooter scoot becane meule bike pitbike pit pocket'
    + ' dirt quad mini minimoto engin roues temps 2t 4t tps moteur cylindree cc 50cc 49cc 50 49 cm3 boite vitesse'
    + ' vitesses mecaboite mecaboites automatique auto sportive route'
    + ' petit petite gros grosse grande vieux vieille ancien ancienne neuf neuve nouveau nouvelle recent occasion belle'
    + ' beau cul noir noire blanc blanche rouge bleu bleue vert verte jaune orange gris grise violet violette rose'
    + ' marron beige dore argent kaki chinoise chinois chine japonaise italienne espagnole francaise importee'
    + ' qwerty azerty asdf qsdf wxcv abc abcd xyz toto tata titi tutu foo'
    + ' carte papiers facture plaque immatriculation chassis cadre serie premier premiere 1er actuel actuelle courant'
    + ' celle celui ceux mienne mien sienne quelque qqch qqc etc facile difficile rapide vite urgent cadeau offrir'
    + ' neveu niece enfant gamin gosse mari femme beaucoup deux trois quatre cinq six cinquante cent mille taille'
    + ' longue courte haute basse plate'
    /* v3 — verbes, adverbes, interjections et noms des NON-RÉPONSES (vérificateur t1) ; aucun n'est un modèle réel */
    + ' vraiment franchement honnetement serieux serieusement desole desolee sorry pardon oups excuse excusez dommage'
    + ' faut faudra faudrait jcp chp jpp jsuis chui chuis jse jsai jsp jcrois jpense jvais jdois jregarde'
    + ' vais va vas allons allez vont aller irai ira dois doit devons devez doivent devoir devrais devrait peux pouvons'
    + ' pouvez peuvent pourrais pourrait pouvoir veux veut voulons voulez voudrais voulais vouloir fais fait faire ferai'
    + ' fera cherche cherches cherchons cherchez chercher chercherai trouve trouves trouvee trouver trouvais retrouve'
    + ' retrouver introuvable regarderai regardes check checke checker checkerai redis redire redirai reviendrai revient'
    + ' retourne retourner enverrai donne donner donnerai indique indiquer indiquerai note notee noter noterai ecris'
    + ' ecrire ecrirai renseigner renseignerai mets mettre mettrai rajoute rajouter rajouterai ajoute ajouter ajouterai'
    + ' achete acheter achetee acquis recupere recuperer recuperee eu avoir aurai avais avait ont sont suis es sommes'
    + ' etes sera serai serait etais decide decidee indecis perdu perdue paume connu connue retenu illisible efface'
    + ' alors donc mais car ni or puis ensuite sinon enfin bref voila voici quand comment pourquoi combien jamais'
    + ' toujours souvent parfois ici labas maintenant aujourdhui hui hier soir matin midi nuit semaine semaines mois'
    + ' jour jours fois heure heures lundi mardi mercredi jeudi vendredi samedi dimanche prochain prochaine'
    + ' prochainement plutot assez presque juste seulement carrement grave tantot rapidement'
    + ' euh heu hum hmm hmmm pff pfff bof bah ben beh hein ouais ouai mouais ah oh eh ha bon wesh hey coucou'
    + ' habitude base vendeur vendeuse bataillon souci soucis probleme question reponse info infos information'
    + ' informations detail details precision precisions aide besoin choix hasard memoire tete flemme galere erreur'
    + ' oubli nul nulle proprio proprietaire boutique site internet leboncoin lbc bonne mauvaise mauvais excellente'
    + ' annees ans decennie epoque fin debut milieu'
    + ' dunno dont know not maybe unknown forgot later soon wait'
    /* v4 — l'argot et les formes collées des non-réponses (vérificateur du 02/10 : « jsaispas », « chépas », « osef »,
       « balec », « tkt », « kesako », « random », « mystère »…) ; aucun n'est un modèle réel (banc K3) */
    + ' jsaispas jsaipas jsaispa jsaipa jesaipas jesaispa jesaipa nesaispas nsaispas nsaipas jsaispu jsaipu chaipu'
    + ' che chepas chaipas chaipa jsepa jsepas jsepu jcpas jcpa jcp jpense jsuispas jsuipa jsuispa jsuipas chuipas'
    + ' jtedis jtedirai jte jvai jve jpeux jpx jregarderai jconfirme jverifie jsp jspa jspas jspp jsp chpa'
    + ' osef osf balec balek blc bref nimp nimporte nimportequoi nawak nimportnawak tkt tqt kesako keskecest random'
    + ' rdm whatever whatevr nothing nada nan nope rien rienn mystere mysterieux mysterieuse secret secrete surprise'
    + ' dispo indispo plutard ptet ptetre pe surement idk dk idc nsm frr frero wsh mec gars meuf bro poto'
    + ' bidon fake faux vrai test tests testing lambda kif kifkif pareil inconu incconu inconnus'
    + ' lequel laquelle lesquels lesquelles quoique quelconques nimportelequel nimportequel'
    /* v5 — argot relevé par le témoin neuf du 05/10 (« Gilera azy », « Beta vazy » demandaient la case) */
    + ' azy vazy vasy'
    /* v6 — des catégories qui ne sont JAMAIS un nom de modèle (vérificateur du 05/10 : « Motocross 125 », « Dirtbike 125 ») */
    + ' motocross dirtbike dirtbikes supermot supermoto minicross');
  var AMBIGUS = { se: ' sherco scherco ', te: ' husqvarna husquarna husky ', sms: ' husqvarna husquarna husky ',
    /* v4 : « Mobylette » est un modèle juste après Motobécane / MBK (« Motobécane Mobylette », « MBK Mobylette
       Club ») et une marque ailleurs (« Mobylette AV88 ») ; « Bleue » (la Motobécane AV88 « Bleue ») ; « BB » (Peugeot) */
    mobylette: ' motobecane motobecanne motoconfort mbk ', bleue: ' motobecane motobecanne motoconfort mbk mobylette ',
    bb: ' peugeot peugot peugeut pegeot ',
    /* v6 : « XX » est un modèle juste après Fantic (« Fantic XX 125 ») ; ailleurs c'est un bouche-trou (« Peugeot xx ») */
    xx: ' fantic fantik ',
    /* v6 : « PE » est un modèle juste après Suzuki (« Suzuki PE 175 ») ; ailleurs c'est « peut-être » (« Derbi Senda pe ») */
    pe: ' suzuki susuki ' };
  /* v6 (1) : les CYLINDRÉES ne sont pas des modèles (« Honda 125 », « KTM 250 » passaient en un clic : vérificateur du
     05/10, défaut bloquant). Ni 103, 104, 105 (Peugeot), ni 330, 660, 1010, 3800 (Solex), ni 901 (Junak) : ce sont des
     modèles. Retirées AVANT de classer les mots (cyl()). */
  var CYL = dico('050 060 065 070 080 085 090 100 110 120 125 135 140 150 160 175 180 190 200 220 230 240 250 260 270 280'
    + ' 300 310 320 350 360 380 390 400 420 430 440 450 460 480 490 500 510 520 525 530 550 560 570 600 620 640 650 680'
    + ' 690 700 750 790 800 850 890 900 950 990 1000 1100 1200 1250 1300 1600 1800');
  /* v6 (2) : les CATÉGORIES de moto ne sont un nom de modèle que JUSTE APRÈS une marque (et alors avec la case : « Beta
     Motard », « Fantic Enduro 50 », « Derbi Cross City ») ; ailleurs elles ne disent rien (« Cross 125 », « Cross SX ») */
  var GENRE = dico('cross enduro motard supermotard trail trial roadster naked');
  var CLAVIER = ['azertyuiop', 'qsdfghjklm', 'wxcvbn', 'qwertyuiop', 'asdfghjkl', 'zxcvbnm'];
  var ALPHA = 'abcdefghijklmnopqrstuvwxyz', CHIF = '0123456789';
  /* après ces mots, un nombre de 2 chiffres est une époque ou un âge (« des années 90 », « depuis 10 ans »), pas un modèle */
  var TEMPS = dico('annees annee ans an depuis vers fin debut milieu epoque decennie il y a');
  /* v6 (1) : une cylindrée seule (« 125 »), suivie de cc / cm3 (« 125cc », « 80cc », « 250cm3 ») ou d'UNE lettre
     (« 125R », « 125i ») ; « DT125 », « R125 », « 103L » ne sont pas touchés (une marque de modèle y est collée) */
  function cyl(x) {
    if (RIEN[x]) return false;   /* « 50 », « 50cc », « 49cc » restent des mots vides : le voisinage des autres mots ne change pas */
    if (CYL[x]) return true;
    var n = x.replace(/(cc|cm3|cmc|cm)$/, '');
    if (n !== x && /^[0-9]{2,4}$/.test(n)) return true;
    n = x.replace(/[a-z]$/, '');
    return n !== x && !!CYL[n];
  }
  function clavier(w) { if (w.length < 4) return false; for (var i = 0; i < CLAVIER.length; i++) if (CLAVIER[i].indexOf(w) >= 0) return true; return false; }
  /* une suite (« abc », « 123 ») de 3 caractères ou plus dans un code : « abc123 », « 1234 » ne sont pas des modèles */
  function suite(w) {
    var l = w.replace(/[0-9]+/g, ' ').split(' '), c = w.replace(/[a-z]+/g, ' ').split(' ');
    for (var i = 0; i < l.length; i++) if (l[i].length >= 3 && ALPHA.indexOf(l[i]) >= 0) return true;
    for (var j = 0; j < c.length; j++) if (c[j].length >= 3 && CHIF.indexOf(c[j]) >= 0) return true;
    return false;
  }
  /* une lettre de plus, de moins, changée ou deux lettres inversées (marques de 5 lettres ou plus) */
  function proche(a, b) {
    if (a === b) return true;
    var la = a.length, lb = b.length, i = 0;
    if (Math.abs(la - lb) > 1) return false;
    while (i < la && i < lb && a.charAt(i) === b.charAt(i)) i++;
    if (la === lb) return a.slice(i + 1) === b.slice(i + 1) || (a.charAt(i) === b.charAt(i + 1) && a.charAt(i + 1) === b.charAt(i) && a.slice(i + 2) === b.slice(i + 2));
    return la > lb ? a.slice(i + 1) === b.slice(i) : a.slice(i) === b.slice(i + 1);
  }
  var LONGUES = Object.keys(MARQUES).filter(function (m) { return m.length >= 5; });
  /* 6 lettres au moins des deux côtés : à 5, « cross » (Derbi Cross City) était pris pour « crois » (mesuré, K2-corpus) */
  var RIEN_LONGS = Object.keys(RIEN).filter(function (m) { return m.length >= 6 && !/[0-9]/.test(m); });
  /* la marque (forme de la liste) que désigne ce mot, ou '' */
  function marque(x) {
    if (MARQUES[x]) return x;
    if (x.length < 5 || RIEN[x] || MODELES[x] || APRES[x] || GENRE[x] || /[0-9]/.test(x)) return '';
    for (var i = 0; i < LONGUES.length; i++) if (proche(x, LONGUES[i])) return LONGUES[i];
    return '';
  }
  /* v4 (a) : un mot de RIEN sous une forme FLÉCHIE (pluriel, féminin : idées, ignorée, pareille, anciennes) ou avec
     UNE faute sur un mot de 6 lettres ou plus (inconue, aucunee, randomm) — jamais un modèle connu */
  function rien(x) {
    if (RIEN[x]) return true;
    if (MODELES[x] || APRES[x] || GENRE[x] || /[0-9]/.test(x) || x.length < 4) return false;
    var b = x.charAt(x.length - 1) === 's' ? x.slice(0, -1) : x, c = [b];
    if (b.charAt(b.length - 1) === 'e') c.push(b.slice(0, -1));
    if (/(ll|nn)e$/.test(b)) c.push(b.slice(0, -2));
    for (var i = 0; i < c.length; i++) if (c[i].length >= 3 && RIEN[c[i]]) return true;
    if (x.length >= 6) for (var j = 0; j < RIEN_LONGS.length; j++) if (proche(x, RIEN_LONGS[j]) || proche(b, RIEN_LONGS[j])) return true;
    return false;
  }
  /* une lettre seule suivie d'un tiret se colle au mot suivant : « X-Ray » -> « xray », « T-Max » -> « tmax » (2e témoin neuf) */
  function mots(v) {
    var s = ' ' + String(v || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/(^|[^a-z0-9])([a-z])-(?=[a-z0-9])/g, '$1$2').replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
    for (var i = 0; i < DEUX_MOTS.length; i++) s = s.split(' ' + DEUX_MOTS[i][0] + ' ').join(' ' + DEUX_MOTS[i][1] + ' ');
    return s.trim().split(' ').filter(function (x) { return !!x; });
  }
  /* '' = bon ; sinon la raison du refus :
     'vide'    rien qui ressemble à une moto ; 'marque' la marque seule ; 'modele' le modèle seul (sans marque) ;
     'inconnu' ni marque ni modèle reconnus, et pas de quoi y voir une marque absente + un modèle ;
     'douteux' (v4) une marque connue + seulement des mots inconnus (ou un nombre de 2 chiffres) : accepté
               SEULEMENT si le client coche « c'est bien le nom exact de ma moto » (l'interface s'en charge) ;
     'hesite'  (v5) une saisie qui serait acceptée ('' ou 'douteux') mais qui dit elle-même qu'elle n'est pas sûre */
  /* v5 : les mots qui disent « je ne suis pas sûr » (formes déjà passées par mots() : sans accent, minuscules, collées) */
  var HESITE = dico(
    'ou voire crois croit croyais jcrois pense pensais jpense suppose supposons peutetre ptet ptetre probablement'
    + ' probable normalement priori semble semblait hesite hesitation incertain incertaine certitude approximativement'
    + ' environ genre sorte maybe jsp jspa jspas jspp nsp jcp jcpa jcpas chepa chepas chaipa chaipas chaipu jsaispas'
    + ' jsaipas jsaispa jsaipa jesaispas jesaipas jesaispa jesaipa saispas nesaispas nsaispas nsaipas jsaispu jsaipu'
    + ' jsepa jsepas jsepu idk dunno unknown oublie oubliee oublier souviens souvenir rappelle'
    /* v6 (4) — par FAMILLES (vérificateur du 05/10 : « sûrement », « sans doute », « à vérifier », « apparemment »…) :
       probabilité */
    + ' surement doute apparemment vraisemblablement visiblement possiblement eventuellement potentiellement'
    + ' theoriquement logiquement principe plutot quasi quasiment approx approximatif approximative env estime estimation'
    /* croyance, ouï-dire, mémoire (« je dirais », « on dirait », « il paraît », « croix » pour « crois », « si je me
       trompe pas », « sauf erreur », « de mémoire ») */
    + ' croix dirais dirait parait paraitrait presume presumee trompe trompes sauf memoire'
    /* « à vérifier / à confirmer / à préciser », plus tard (l'infinitif et le futur ; « vérifié », « confirmé » au passé
       disent le contraire : ils ne sont pas ici) */
    + ' verifier verif verifierai verifiera confirmer confirmerai confirmera definir determiner preciser revoir completer'
    /* une autre moto que la sienne (« copie de », « genre de », « qui ressemble à ») ; « sinon » (= ou) */
    + ' ressemble ressemblant similaire equivalent replique clone imitation copie facon sinon pe');
  /* « je sais pas », « je sais vraiment pas », « j'en sais rien », « jsais pas », « chais pas » */
  var SAVOIR = dico('sais sait sai se connais connait souviens rappelle jsais jsai chais chai'), NEGATION = dico('pas plus plu pa pu rien');
  /* v6 : la négation (ou l'à-peu-près) à DEUX mots près : « pas sûr », « pas trop sûr », « pas vraiment certain », « non
     vérifié », « aucune idée », « presque sûr » */
  var NEGS = dico('pas plus plu pa pu non aucune aucun jamais presque quasi quasiment moyen moyennement');
  var SUR = dico('sur sure surs sures certain certaine certains certaines idee garanti garantie verifie verifiee confirme'
    + ' confirmee certifie certifiee');
  /* les participes qui AFFIRMENT (« vérifié sur la carte grise ») : jamais pris pour une faute d'un mot d'hésitation */
  var AFFIRME = dico('confirme confirmee confirmes verifie verifiee verifies precise precisee determine determinee complete'
    + ' completee defini definie certifie certifiee');
  var HESITE_LONGS = Object.keys(HESITE).filter(function (m) { return m.length >= 7; });
  /* « ? », « ¿ », « ~ », « ± », « +/- », 🤔 (paire de substitution, sans le drapeau « u » : un vieux navigateur
     refuserait tout le script) */
  var SIGNES = ['?', '¿', '~', '±', '+/-', '+-', '🤔'];
  function hesitation(v, w) {
    var s = String(v || '');
    for (var k = 0; k < SIGNES.length; k++) if (s.indexOf(SIGNES[k]) >= 0) return true;
    for (var i = 0; i < w.length; i++) {
      var x = w[i];
      /* un mot AMBIGU juste après sa marque est un modèle (« Suzuki PE ») : pas une hésitation */
      if (AMBIGUS.hasOwnProperty(x) && i > 0 && AMBIGUS[x].indexOf(' ' + marque(w[i - 1]) + ' ') >= 0) continue;
      if (HESITE[x]) return true;
      if (SAVOIR[x] && (NEGATION[w[i + 1]] || NEGATION[w[i + 2]])) return true;    /* « je sais (vraiment) pas » */
      if (NEGS[x] && (SUR[w[i + 1]] || SUR[w[i + 2]])) return true;                /* « pas (trop) sûr », « non vérifié » */
      if (x === 'a' && (w[i + 1] === 'voir' || (w[i + 1] === 'peu' && w[i + 2] === 'pres'))) return true;   /* « à voir », « à peu près » */
      /* une faute d'une lettre sur un mot d'hésitation de 7 lettres ou plus (« probablment », « surment ») */
      if (x.length >= 6 && !AFFIRME[x] && !MODELES[x] && !APRES[x] && !MARQUES[x])
        for (var j = 0; j < HESITE_LONGS.length; j++) if (proche(x, HESITE_LONGS[j])) return true;
    }
    return false;
  }
  /* v6 (3) : DEUX motos sans « ou ». La saisie BRUTE est coupée aux séparateurs (/ + & , ; | « - » espacé, et les mots
     « et », « voir » (pour « voire »), « or », « sinon ») ; deux morceaux qui nomment chacun une moto, une marque ou un
     modèle = deux motos. Un morceau qui ne nomme rien (« 2008 », « moteur AM6 », « voir photo », « kit 70cc ») ne compte
     pas. */
  function nomme(p) { var r = raison4(p); return r === '' || r === 'douteux' || r === 'modele' || r === 'marque'; }
  function deuxMotos(v) {
    var p = String(v || '').split(/\s*[\/+&,;|]\s*|\s+[-–—]\s+|\s+(?:et|voir|or|sinon)\s+/i), n = 0;
    for (var i = 0; i < p.length; i++) if (p[i] && p[i].trim() && nomme(p[i])) n++;
    return n >= 2;
  }
  /* … et deux marques qui portent chacune un modèle, sans séparateur (« Peugeot XR6 Peugeot XPS ») — sauf la marque d'un
     MOTEUR ou d'une pièce (« Rieju MRT moteur Derbi EBE ») et « Mobylette » juste après Motobécane / MBK (un modèle) */
  var MECA = dico('moteur moteurs bloc base motorisation motorise motorisee equipe equipee carbu carburateur pot echappement'
    + ' kit cylindre piston allumage');
  function deuxMarques(v) {
    var w = mots(v).filter(function (x) { return !cyl(x); }), deb = [], n = 0;
    for (var i = 0; i < w.length; i++) {
      var amb = AMBIGUS.hasOwnProperty(w[i]) && i > 0 && AMBIGUS[w[i]].indexOf(' ' + marque(w[i - 1]) + ' ') >= 0;
      if (marque(w[i]) && !amb && !(i > 0 && MECA[w[i - 1]])) deb.push(i);
    }
    if (!deb.length) return false;
    /* les morceaux : ce qui précède la 1re marque (« Ride RXT » : marque absente de la liste), puis chaque marque jusqu'à la
       suivante ; un morceau compte s'il serait accepté seul ('' ou la case : « Beta Motard Peugeot XR6 ») */
    var bornes = (deb[0] > 0 ? [0] : []).concat(deb, [w.length]);
    for (var k = 0; k + 1 < bornes.length; k++) { var r = raison4(w.slice(bornes[k], bornes[k + 1]).join(' ')); if (r === '' || r === 'douteux') n++; }
    return n >= 2;
  }
  function raison(v) {
    var r = raison4(v);
    if (r !== '' && r !== 'douteux') return r;
    return hesitation(v, mots(v)) || deuxMotos(v) || deuxMarques(v) ? 'hesite' : r;
  }
  function raison4(v) {
    /* v6 (1) : les cylindrées retirées AVANT de classer les mots */
    var w = mots(v).filter(function (x) { return !cyl(x); }), cl = [], mq = [], marques = 0, modeles = 0, codes = 0, faibles = 0, utiles = 0, libres = 0;
    /* 1. ce qu'est chaque mot : 'M' marque, 'm' modèle, 'c' code / nombre de modèle, 'f' nombre de 2 chiffres hors liste
          (faible), 'n' nombre de 4 chiffres (code s'il touche une marque, vu en 2), 'u' mot inconnu, '' rien */
    for (var i = 0; i < w.length; i++) {
      var x = w[i], c = '', q = marque(x), p = i > 0 ? cl[i - 1] : '';
      /* « SE », « TE », « SMS », « Mobylette », « Bleue », « BB » sont des modèles JUSTE APRÈS LEUR marque (« Sherco SE
         50 », « Motobécane Bleue » oui ; « Peugeot je te dirai », « Peugeot bleue » non) */
      if (AMBIGUS.hasOwnProperty(x) && i > 0 && AMBIGUS[x].indexOf(' ' + mq[i - 1] + ' ') >= 0) c = 'm';
      else if (q) c = 'M';
      else if (MODELES[x]) c = 'm';
      else if (APRES[x] && p === 'M') c = 'm';
      else if (GENRE[x]) c = p === 'M' ? 'u' : '';   /* v6 (2) : « Beta Motard » (case) ; « Cross 125 », « Cross SX » : rien */
      else if (/^[0-9]{4}$/.test(x)) c = (+x >= 1900 && +x <= 2099) || suite(x) || /^(.)\1+$/.test(x) ? '' : 'n';
      else if (rien(x) || x.length < 2 || /^(.)\1+$/.test(x) || clavier(x)) c = '';
      else if (/^[0-9]{2}$/.test(x)) c = i > 0 && TEMPS[w[i - 1]] ? '' : 'f';
      /* v6 : un nombre de 3 chiffres qui n'est ni une cylindrée (retirée plus haut) ni un modèle connu (« 103 », « 105 »,
         « 901 », liste MODELES) ne suffit plus seul : 'f' comme un nombre de 2 chiffres (« Yamaha 314 » -> la case) */
      else if (/[0-9]/.test(x)) c = /^[0-9]+$/.test(x) ? (x.length === 3 && !suite(x) ? 'f' : '') : (x.length <= 8 && !suite(x) ? 'c' : '');
      else if (!/[aeiouy]/.test(x)) c = x.length <= 4 ? 'c' : '';   /* « MTX », « XSM », « RXT » ; « qsdfg » non */
      /* v6 : 2 lettres avec voyelle JUSTE APRÈS une marque = un mot inconnu (« Suzuki PE 175 », « Yamaha TY 125 », que la
         cylindrée sauvait jusqu'ici : la case) */
      else if (x.length >= 3 || p === 'M') c = 'u';
      cl.push(c); mq.push(q);
    }
    /* 2. un nombre de 4 chiffres n'est un modèle que collé à une marque (« Solex 3800 ») ; un mot inconnu n'est un nom
          de modèle que s'il TOUCHE une marque, un modèle ou un code */
    for (var k = 0; k < cl.length; k++) if (cl[k] === 'n') cl[k] = (cl[k - 1] === 'M' || cl[k + 1] === 'M') ? 'c' : '';
    for (var j = 0; j < cl.length; j++) {
      if (cl[j] === 'M') marques++; else if (cl[j] === 'm') modeles++; else if (cl[j] === 'c') codes++; else if (cl[j] === 'f') faibles++;
      else if (cl[j] === 'u') { var a = cl[j - 1], s = cl[j + 1]; if (/^[Mmcf]$/.test(a || '') || /^[Mmcf]$/.test(s || '')) utiles++; else libres++; }
    }
    if (marques) return (modeles || codes) ? '' : (utiles || faibles) ? 'douteux' : 'marque';
    if (modeles) return (modeles >= 2 || codes || utiles || faibles) ? '' : 'modele';
    if (codes && utiles) return '';                            /* marque absente de la liste + un modèle qui touche son code */
    return (codes || utiles || libres || faibles) ? 'inconnu' : 'vide';
  }
  function anOk(v) { var s = String(v || '').trim(); if (!/^[0-9]{4}$/.test(s)) return false; var n = +s; return n >= AN_MIN && n <= AN_MAX; }
  return { raison: raison, anOk: anOk, AN_MIN: AN_MIN, AN_MAX: AN_MAX, EXEMPLE: 'Rieju RS3 50' };
})();
/* </bks-regle-modele v6> */

  var PREFIX = "kit-deco-bks-50cc-semi-perso";

  /* Palette BKS (identique a COLORS du configurateur FUSION). cle = forme normalisee. */
  var PALETTE = ["noir", "blanc", "gris", "rouge", "orange", "jaune", "dore",
                 "vert", "turquoise", "bleu clair", "bleu", "violet", "rose"];

  /* Kit couleur UNIE : couleur -> handle. Depublies a ce jour, gardes pour le futur. */
  var UNI = {
    "blanc": PREFIX + "-blanc",
    "bleu": PREFIX + "-bleu",
    "bleu clair": PREFIX + "-bleu-clair",
    "gris": PREFIX + "-gris",
    "jaune": PREFIX + "-jaune",
    "orange": PREFIX + "-orange",
    "rose": PREFIX + "-rose",
    "turquoise": PREFIX + "-turquoise",
    "vert": PREFIX + "-vert",
    "violet": PREFIX + "-violet"
  };

  /* REPLI pour les couleurs sans kit complet assorti (noir, blanc, gris, bleu clair, dore
     = 43,6 % des selles vendues sur 12 mois). On propose alors la piece deco la plus vendue
     du catalogue (Kit Deco Carter, 16 ventes sur 12 mois, prix d'impulsion) — SANS jamais
     pretendre qu'elle est assortie, puisqu'elle ne l'est pas. Honnetete du libelle avant tout. */
  var REPLI = "kit-deco-carter";

  /* Kits BI-COLORES reellement publies. ATTENTION : le handle "-orange-jaune-copy"
     porte le titre "Orange/Vert" — on se fie aux couleurs declarees ici, pas au handle. */
  var BI = [
    { handle: PREFIX + "-bleu-rouge",        couleurs: ["bleu", "rouge"] },
    { handle: PREFIX + "-jaune-turquoise",   couleurs: ["jaune", "turquoise"] },
    { handle: PREFIX + "-orange-jaune",      couleurs: ["orange", "jaune"] },
    { handle: PREFIX + "-orange-jaune-copy", couleurs: ["orange", "vert"] },
    { handle: PREFIX + "-rose-rouge",        couleurs: ["rose", "rouge"] },
    { handle: PREFIX + "-turquoise-violet",  couleurs: ["turquoise", "violet"] },
    { handle: PREFIX + "-vert-bleu",         couleurs: ["vert", "bleu"] }
  ];

  /* --- MARQUES & MODELES 50cc couverts par BKS (selecteur de la carte upsell) ---------
     Liste EDITABLE : ajouter / retirer une marque ou un modele ici suffit, rien d'autre
     n'est a toucher dans le fichier. Aucun modele n'est invente au vol : ce tableau est
     la seule source. La puce "Autre modele" est ajoutee automatiquement a chaque marque
     pour ne jamais bloquer un client dont la moto n'est pas listee. */
  var MOTOS = [
    { marque: "Derbi",   modeles: ["Senda DRD", "Senda X-Treme", "Senda Racing", "Senda SM"] },
    { marque: "Rieju",   modeles: ["MRT", "MRT Pro", "SMX"] },
    { marque: "Beta",    modeles: ["RR 50", "RR Track", "RR SM"] },
    { marque: "Gilera",  modeles: ["SMT", "RCR"] },
    { marque: "Aprilia", modeles: ["SX 50", "RX 50"] },
    { marque: "Sherco",  modeles: ["SE-R 50", "SM-R 50"] },
    { marque: "MBK",     modeles: ["Booster", "Nitro", "Stunt", "X-Limit"] },
    { marque: "Yamaha",  modeles: ["DT 50", "TZR 50", "Aerox"] },
    { marque: "Peugeot", modeles: ["XPS", "XP6"] },
    { marque: "Piaggio", modeles: ["Zip"] },
    { marque: "Fantic",  modeles: ["XE 50", "XM 50"] },
    { marque: "KTM",     modeles: ["SX 50", "SX-E 5"] },
    { marque: "Honda",   modeles: ["Dax 50", "Monkey 50", "Vision 50"] },
    { marque: "Husqvarna", modeles: ["TC 50", "TC 65"] },
    { marque: "Kawasaki", modeles: ["KX 65", "KX 85"] },
    { marque: "GasGas",  modeles: ["MC 50", "MC 65"] },
    { marque: "Suzuki",  modeles: ["RM 65"] }
  ];
  var MOTO_AUTRE = "Autre modèle";
  /* v2 : un identifiant par encart (la page panier peut en montrer deux : page + tiroir) et UNE zone d'annonce,
     remplie seulement quand un ajout est refusé (jamais à la frappe) */
  var SEQ_AUTRE = 0;
  /* 02/10 (vérificateur rendu/a11y) : la zone n'existait qu'au 1er refus (créée puis remplie 60 ms plus tard) — souvent
     ignorée la 1re fois par VoiceOver. Elle est posée VIDE dès qu'un sélecteur de moto est construit (selecteurMoto). */
  function zoneAutre() {
    var z = document.getElementById("bks-kd-annonce");
    if (!z && document.body) { z = document.createElement("div"); z.id = "bks-kd-annonce"; z.className = "bks-kd-annonce"; z.setAttribute("aria-live", "assertive"); z.setAttribute("aria-atomic", "true"); document.body.appendChild(z); }
    return z;
  }
  function annonceAutre(t) {
    var z = zoneAutre(); if (!z) return;
    z.textContent = "";
    setTimeout(function () { z.textContent = t; }, 60);
  }
  /* Le choix survit aux reconstructions de la carte (le panier se rafraichit souvent). */
  var MOTO_KEY = "bks_kitdeco_moto";

  var OPTOUT = "bks_kitdeco_refus";
  /* Tags de la mecanique de remise Shopify (reduction automatique "achete une selle -> -10 %").
     TAG_SELLE conditionne la remise ; TAG_KIT et TAG_ACC designent les produits remises. */
  var TAG_SELLE = "bks-selle", TAG_KIT = "bks-kitdeco-complet", TAG_ACC = "bks-accessoire";
  var REMISE = 0.10;
  var CACHE = {};          // handle -> produit (ou null si indisponible)
  var BUSY = false, TMR = null;

  function norm(s) {
    try {
      return (s || "").toLowerCase().normalize("NFD")
        .replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ").trim();
    } catch (e) { return (s || "").toLowerCase().trim(); }
  }
  function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function euro(cents) {
    try { return (cents / 100).toFixed(2).replace(".", ",") + " €"; } catch (e) { return ""; }
  }
  /* Vignette CDN. Shopify renvoie des URL sans protocole ("//cdn.shopify.com/...") : certains
     contextes ne les chargent pas, on force donc https:. Redimensionnement via le parametre
     officiel &width= (le suffixe _200x dans le nom de fichier n'est pas fiable partout). */
  function vignette(url) {
    if (!url) return "";
    var u = String(url);
    if (u.indexOf("//") === 0) u = "https:" + u;
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=200";
  }

  function getCart() {
    return fetch("/cart.js", { cache: "no-cache", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  /* --- Couleur du dessus de la selle, quel que soit le configurateur d'origine --- */
  var PRIORITE = ["dessus", "couleur", "couleur dessus", "dessus de selle", "coloris",
                  "descriptif", "matieres", "matiere"];

  function couleurDepuisTexte(txt) {
    var t = norm(txt);
    if (!t) return null;
    // "bleu clair" avant "bleu" : la palette est deja ordonnee du plus specifique au plus court
    var ordre = PALETTE.slice().sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < ordre.length; i++) {
      var c = ordre[i];
      if (new RegExp("(^|[^a-z])" + c.replace(" ", "\\s+") + "([^a-z]|$)").test(t)) return c;
    }
    return null;
  }

  /* La marque / le modele sont peut-etre DEJA connus : le configurateur de selle custom
     (bks-selle-custom-v2.js) les ecrit en proprietes de ligne. On les relit ici pour
     pre-selectionner les puces au lieu de redemander au client ce qu'il a deja saisi. */
  var MOTO_PANIER = null;
  function motoDepuisPanier(cart) {
    try {
      var items = (cart && cart.items) || [];
      var bases = items.filter(function (it) {
        return it.properties && it.properties._bks_role === "base";
      });
      var cibles = bases.length ? bases : items;
      for (var i = 0; i < cibles.length; i++) {
        var p = cibles[i].properties || {};
        var mk = p["Marque"] || p["marque"] || "";
        var md = p["Mod\u00e8le"] || p["Modele"] || p["mod\u00e8le"] || "";
        var an = p["Ann\u00e9e"] || p["Annee"] || p["ann\u00e9e"] || p["year"] || "";
        mk = String(mk || "").trim();
        if (mk) return { m: mk, x: String(md || "").trim(), a: String(an || "").trim() };
      }
    } catch (e) {}
    return null;
  }
  function couleurSelle(cart) {
    try {
      var items = (cart && cart.items) || [];
      // 1) la ligne "base" d'un configurateur, sinon n'importe quelle ligne a proprietes
      var bases = items.filter(function (it) {
        return it.properties && it.properties._bks_role === "base";
      });
      var cibles = bases.length ? bases : items;
      for (var i = 0; i < cibles.length; i++) {
        var props = cibles[i].properties || {};
        // a) proprietes prioritaires
        for (var p = 0; p < PRIORITE.length; p++) {
          for (var k in props) {
            if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
            if (k.charAt(0) === "_") continue;              // proprietes techniques
            if (norm(k) !== PRIORITE[p]) continue;
            var c = couleurDepuisTexte(props[k]);
            if (c) return c;
          }
        }
        // b) a defaut, n'importe quelle propriete visible
        for (var k2 in props) {
          if (!Object.prototype.hasOwnProperty.call(props, k2)) continue;
          if (k2.charAt(0) === "_") continue;
          var c2 = couleurDepuisTexte(props[k2]);
          if (c2) return c2;
        }
      }
    } catch (e) {}
    return null;
  }

  /* --- Resolution du kit assorti (catalogue en direct, rien en dur) --- */
  function produit(handle) {
    if (Object.prototype.hasOwnProperty.call(CACHE, handle)) return Promise.resolve(CACHE[handle]);
    // cache:"no-cache" indispensable : sans lui, le navigateur peut servir une fiche produit
    // anterieure a une modification de tags ou de prix, et l'offre serait calculee sur des
    // donnees perimees (constate en test reel : les tags de remise n'etaient pas vus).
    return fetch("/products/" + handle + ".js", { cache: "no-cache", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) {
        // produit inexistant, depublie ou indisponible => pas d'offre
        if (!p || !p.available) p = null;
        CACHE[handle] = p;
        return p;
      });
  }

  function kitAssorti(couleur) {
    if (!couleur) return Promise.resolve(null);
    var uni = UNI[couleur];
    // 1) couleur unie exacte
    return (uni ? produit(uni) : Promise.resolve(null)).then(function (p) {
      if (p) return { produit: p, type: "exact", couleur: couleur };
      // 2) bi-colore contenant la couleur
      var candidats = BI.filter(function (b) { return b.couleurs.indexOf(couleur) >= 0; });
      var suite = Promise.resolve(null);
      candidats.forEach(function (c) {
        suite = suite.then(function (trouve) {
          if (trouve) return trouve;
          return produit(c.handle).then(function (pp) {
            return pp ? { produit: pp, type: "accorde", couleur: couleur } : null;
          });
        });
      });
      // 3) repli non assorti (libelle honnete, aucune promesse de couleur)
      return suite.then(function (trouve) {
        if (trouve) return trouve;
        return produit(REPLI).then(function (pp) {
          return pp ? { produit: pp, type: "repli", couleur: couleur } : null;
        });
      });
    });
  }

  /* --- Le panier contient-il une selle REELLEMENT eligible a la remise ? ---
     La remise Shopify se declenche sur le tag "bks-selle". On ne se contente donc pas d'avoir
     detecte une couleur : on verifie le tag du produit, sinon on annoncerait un -10 % qui ne
     s'appliquerait jamais au paiement. On borne a 4 lignes pour ne pas multiplier les appels. */
  function selleEligible(cart) {
    try {
      // NB : test des lignes cadeaux ecrit ici en toutes lettres. Ne PAS appeler isGift() :
      // cette fonction appartient a bks-gift-sync.js et n'existe pas dans ce module — l'appel
      // levait une ReferenceError avalee par le try/catch, et l'eligibilite retombait toujours
      // a false (donc aucune remise ne s'affichait jamais).
      var items = (cart.items || []).filter(function (it) {
        var props = it.properties || {};
        return it.handle && !props._bks_gift;
      }).slice(0, 4);
      if (!items.length) return Promise.resolve(false);
      var suite = Promise.resolve(false);
      items.forEach(function (it) {
        suite = suite.then(function (trouve) {
          if (trouve) return true;
          // fetch direct : produit() ecarte les produits indisponibles, or une selle deja au panier
          // peut l'etre devenue sans que cela change son eligibilite a la remise.
          return fetch("/products/" + it.handle + ".js", { cache: "no-cache", headers: { "Accept": "application/json" } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { return !!(p && (p.tags || []).indexOf(TAG_SELLE) >= 0); })
            .catch(function () { return false; });
        });
      });
      return suite;
    } catch (e) { return Promise.resolve(false); }
  }
  /* Le produit propose est-il dans une collection remisee ? (kit complet ou accessoire) */
  function estRemise(p) {
    try {
      var t = p.tags || [];
      return t.indexOf(TAG_KIT) >= 0 || t.indexOf(TAG_ACC) >= 0;
    } catch (e) { return false; }
  }

  function dejaAuPanier(cart) {
    try {
      return (cart.items || []).some(function (it) {
        var p = it.properties || {};
        if (p._bks_kitdeco) return true;
        return /kit-deco/i.test(it.handle || "") || /kit\s*d[ée]co/i.test(it.product_title || "");
      });
    } catch (e) { return false; }
  }

  /* --- Ajout au panier --- */
  function ajouter(variantId, couleur, type, moto) {
    var props = { "_bks_kitdeco": "1" };
    /* Marque + modele choisis dans les bandes defilantes de la carte. Propriete VISIBLE
       (pas de "_" en tete) : elle apparait dans le panier, sur la commande et dans les
       emails. Facultative : si le client n'a rien choisi, on n'ecrit rien du tout. */
    if (moto) { try { props["Moto"] = String(moto).slice(0, 120); } catch (e) {} }
    // on n'inscrit "Assorti a" que si la couleur correspond vraiment (jamais sur un repli)
    if (couleur && type !== "repli") {
      props["Assorti à"] = couleur.charAt(0).toUpperCase() + couleur.slice(1);
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("ajout refuse");
      // bks-gift-sync.js voit passer /cart/add.js et recalcule les paliers cadeaux tout seul
      try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
      return r;
    });
  }

  /* --- Encart --- */
  var CSS = [
    /* Defense en profondeur (03/09/2026) : le corps du tiroir est une grille CSS ; un item overflow:hidden
       (la barre cadeau .bks-bar3) voit sa rangee ecrasee a sa hauteur minimale quand le contenu depasse
       le tiroir, et deborde alors SUR cet encart. Le correctif principal vit dans bks-shipping-bar.liquid ;
       on le repete ici pour que l'encart reste protege meme si le snippet est un jour reverte. */
    "cart-drawer.cart-drawer::part(body){grid-auto-rows:max-content}",
    /* 02/10 (lot fusion-autre, vérificateur rendu/a11y) : --kd-a #8b5cf6 -> #7c3aed (charte). Blanc sur #8b5cf6 = 4,23:1
       (bouton « Ajouter à ma commande » 13 px, puces modèle / année choisies 12,5 px) ; blanc sur #7c3aed = 5,70:1. */
    ".bks-kd{--kd-a:#7c3aed;--kd-d:#6d28d9;font-family:'Montserrat',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;",
    "background:#fff;border:1.5px solid var(--kd-a);border-radius:14px;padding:14px;margin:16px 0;display:flex;gap:14px;",
    "align-items:center;position:relative;box-shadow:0 3px 14px rgba(109,40,217,.10);box-sizing:border-box}",
    ".bks-kd *{box-sizing:border-box}",
    /* variante avec remise : cadre plus affirme, on veut que ca accroche */
    ".bks-kd--promo{border-width:2px;border-color:var(--kd-d);box-shadow:0 6px 22px rgba(109,40,217,.18)}",
    ".bks-kd__media{position:relative;flex:0 0 88px;width:88px}",
    ".bks-kd__img{width:88px;height:88px;border-radius:10px;object-fit:cover;background:#f4f0ff;display:block}",
    ".bks-kd__off{position:absolute;top:-8px;left:-8px;z-index:2;background:#e2231a;color:#fff;font-size:12px;font-weight:900;",
    "letter-spacing:.2px;padding:5px 8px;border-radius:999px;line-height:1;box-shadow:0 3px 10px rgba(226,35,26,.42);white-space:nowrap}",
    ".bks-kd__body{flex:1;min-width:0;display:flex;flex-direction:column;gap:5px}",
    ".bks-kd__tag{display:inline-block;align-self:flex-start;background:var(--kd-d);color:#fff;font-size:10.5px;font-weight:800;",
    "letter-spacing:.4px;text-transform:uppercase;padding:3px 8px;border-radius:999px;line-height:1.2}",
    ".bks-kd__t{font-size:15px;font-weight:800;color:#1b0e38;margin:0;line-height:1.3}",
    ".bks-kd__p{font-size:12.5px;color:#5b5170;margin:0;line-height:1.4}",
    /* la phrase qui porte l'argument : c'est SA selle qui debloque la remise */
    ".bks-kd__unlock{margin:4px 0 0;font-size:12.5px;line-height:1.4;color:#166534;background:#e9f9ee;",
    "border:1px solid #bbe7c8;border-radius:8px;padding:7px 10px}",
    ".bks-kd__unlock b{color:#0f5132;font-weight:800}",
    ".bks-kd__row{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top:7px}",
    ".bks-kd__prices{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}",
    /* 02/10 : ancien prix barré #9a93ab = 2,94:1 sur blanc -> #5c5f68 (encre secondaire de la charte) = 6,36:1 ; même gris pour la croix « Masquer » (#b3a9c9 = 2,22:1, sous les 3:1 d’une icône) */
    ".bks-kd__old{font-size:14px;color:#5c5f68;text-decoration:line-through}",
    ".bks-kd__price{font-size:21px;font-weight:900;color:var(--kd-d);line-height:1}",
    ".bks-kd__eco{font-size:11.5px;font-weight:700;color:#166534;background:#e9f9ee;padding:2px 7px;border-radius:999px;white-space:nowrap}",
    ".bks-kd__btn{background:var(--kd-a);color:#fff;border:0;font-family:inherit;font-weight:800;font-size:13px;",
    "letter-spacing:.3px;text-transform:uppercase;padding:12px 18px;border-radius:9px;cursor:pointer;line-height:1.2;",
    "transition:filter .15s ease,transform .12s ease}",
    ".bks-kd__btn:hover{filter:brightness(1.08)}",
    ".bks-kd__btn:active{transform:translateY(1px)}",
    ".bks-kd__btn[disabled]{opacity:.6;cursor:default}",
    ".bks-kd__x{position:absolute;top:7px;right:9px;background:none;border:0;font-size:19px;line-height:1;color:#5c5f68;",
    "cursor:pointer;padding:2px 5px;border-radius:6px}",
    ".bks-kd__x:hover{color:#6d28d9;background:#f4f0ff}",
    /* --- Selecteur MARQUE + MODELE : bandes defilantes (scroll-snap) ---
       Additif : n'altere ni la vignette assortie, ni les prix, ni le bouton. */
    ".bks-kd__moto{margin:9px 0 0;padding-top:9px;border-top:1px dashed #e6dffb}",
    ".bks-kd__moto-lbl{margin:0 0 6px;font-size:12px;font-weight:800;color:#1b0e38;line-height:1.35}",
    /* 02/10 (vérificateur rendu/a11y) : la mention #7c7391 = 4,41:1 (12-13 px) — sous 4,5:1, et devenue une CONSIGNE
       quand « Autre modèle » est choisi. « — facultatif… » : #5c5f68 (encre secondaire de la charte, 6,36:1) ;
       « — précise le modèle et l'année ci-dessous » : violet --kd-d #6d28d9 (7,10:1) en gras, comme le récap. */
    ".bks-kd__moto-lbl span{font-weight:600;color:#5c5f68}",
    ".bks-kd__moto-lbl span.is-requis{font-weight:800;color:var(--kd-d)}",
    ".bks-kd__band{display:flex;gap:7px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x proximity;",
    "-webkit-overflow-scrolling:touch;scrollbar-width:thin;padding:4px 4px 7px;margin:0 -4px}",
    /* display:flex ecrase la regle navigateur [hidden]{display:none} : on la retablit */
    ".bks-kd__band[hidden],.bks-kd__moto-pick[hidden]{display:none}",
    ".bks-kd__band::-webkit-scrollbar{height:4px}",
    ".bks-kd__band::-webkit-scrollbar-thumb{background:#d9cffa;border-radius:999px}",
    ".bks-kd__chip{flex:0 0 auto;scroll-snap-align:center;background:#f7f4ff;border:1.5px solid #e3d9fb;",
    "color:#3b2a63;font-family:inherit;font-size:12.5px;font-weight:700;line-height:1;padding:9px 13px;",
    "border-radius:999px;cursor:pointer;white-space:nowrap;",
    "transition:background .14s ease,border-color .14s ease,color .14s ease}",
    ".bks-kd__chip:hover{background:#efe8ff;border-color:#c9b6f7}",
    ".bks-kd__chip:focus-visible{outline:2px solid var(--kd-d);outline-offset:2px}",
    ".bks-kd__chip.is-on{background:var(--kd-d);border-color:var(--kd-d);color:#fff}",
    ".bks-kd__band--mod .bks-kd__chip{background:#fff;border-style:dashed}",
    ".bks-kd__band--mod .bks-kd__chip.is-on{background:var(--kd-a);border-color:var(--kd-a);border-style:solid;color:#fff}",
    ".bks-kd__band--year .bks-kd__chip{background:#fff;border-style:dashed}",
    ".bks-kd__band--year .bks-kd__chip.is-on{background:var(--kd-a);border-color:var(--kd-a);border-style:solid;color:#fff}",
    /* incitation douce tant qu'aucune marque n'est choisie — jamais bloquante */
    ".bks-kd__band--todo .bks-kd__chip{animation:bks-kd-pulse 2.4s ease-in-out infinite}",
    "@keyframes bks-kd-pulse{0%,100%{box-shadow:0 0 0 0 rgba(139,92,246,0)}",
    "50%{box-shadow:0 0 0 3px rgba(139,92,246,.16)}}",
    "@media (prefers-reduced-motion:reduce){.bks-kd__band--todo .bks-kd__chip{animation:none}}",
    ".bks-kd__moto-pick{margin:5px 0 0;font-size:12px;font-weight:700;color:var(--kd-d);line-height:1.35}",
    /* v2 (lot fusion-autre) : « Autre modèle » -> modèle exact + année obligatoires. Champs 16 px (pas de zoom iOS),
       44 px de haut, erreur #b91c1c sur le fond #faf8ff (6,14:1), rouge gardé avec le focus, message 14 px. */
    ".bks-kd__autre{margin:8px 0 0;padding:10px;border:1.5px solid #e3d9fb;border-radius:10px;background:#faf8ff;display:flex;flex-direction:column;gap:5px}",
    ".bks-kd__autre[hidden]{display:none}",
    ".bks-kd__autre-t{margin:0 0 2px;display:flex;align-items:center;flex-wrap:wrap;gap:6px;font-size:13px;font-weight:800;color:#1b0e38}",
    ".bks-kd__autre-req{font-size:10px;font-weight:800;letter-spacing:.4px;text-transform:uppercase;color:#fff;background:var(--kd-d);border-radius:999px;padding:2px 8px}",
    ".bks-kd__autre-l{font-size:12.5px;font-weight:700;color:#1b0e38;margin-top:3px}",
    ".bks-kd__autre-c{width:100%;min-height:44px;padding:0 12px;border:1.5px solid #d8dae0;border-radius:9px;background:#fff;color:#0e0f12;font:inherit;font-size:16px}",
    ".bks-kd__autre-c:focus-visible{outline:2px solid var(--kd-d);outline-offset:2px;border-color:var(--kd-d)}",
    /* 02/10 (vérificateur rendu/a11y, défaut majeur) : un champ fautif focalisé avait le même aspect qu'un champ fautif
       non focalisé (contour rouge sur les deux). Erreur seule = bord rouge + halo léger ; erreur AVEC le focus = bord
       rouge + contour d'encre #1b0e38 décalé de 2 px (sur #faf8ff ≈ 17:1) + halo appuyé. */
    ".bks-kd__autre-c.is-bad{border-color:#b91c1c;outline:none;box-shadow:0 0 0 3px rgba(185,28,28,.12)}",
    ".bks-kd__autre-c.is-bad:focus{border-color:#b91c1c;outline:2px solid #1b0e38;outline-offset:2px;box-shadow:0 0 0 3px rgba(185,28,28,.25)}",
    ".bks-kd__autre-e{margin:4px 0 0;font-size:14px;font-weight:700;line-height:1.4}",
    /* 02/10 (v4) : la case « Oui, « … » est bien le nom exact de ma moto » (modèle 'douteux'). Ligne entière cliquable
       (≥ 44 px), case 22 px, texte #1b0e38 sur blanc ; en faute : le rouge des champs ; focus : contour d'encre 2 px */
    ".bks-kd__conf{display:flex;align-items:flex-start;gap:9px;margin:4px 0 0;padding:10px 11px;min-height:44px;box-sizing:border-box;border:1.5px solid #d8dae0;border-radius:9px;background:#fff}",
    ".bks-kd__conf[hidden]{display:none}",
    ".bks-kd__conf input{flex:none;width:22px;height:22px;margin:0;accent-color:var(--kd-d);cursor:pointer}",
    ".bks-kd__conf input:focus{outline:2px solid #1b0e38;outline-offset:2px}",
    ".bks-kd__conf label{font-size:13.5px;line-height:1.4;font-weight:700;color:#1b0e38;cursor:pointer;overflow-wrap:anywhere}",
    ".bks-kd__conf.is-bad{border-color:#b91c1c;box-shadow:0 0 0 3px rgba(185,28,28,.12)}",
    ".bks-kd__autre-e:empty{display:none}",
    ".bks-kd__autre-e.on{color:#b91c1c}",
    ".bks-kd__autre-e.ok{color:var(--kd-d)}",
    ".bks-kd-annonce{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0}",
    "@media (max-width:560px){.bks-kd__moto-lbl{font-size:13px}",
    ".bks-kd__chip{font-size:13.5px;padding:11px 15px}.bks-kd__moto-pick{font-size:13px}}",
    /* --- Mobile : l'offre doit occuper l'ecran, pas se tasser dans un coin --- */
    "@media (max-width:560px){",
    ".bks-kd{gap:11px;padding:11px;margin:12px 0;border-radius:12px;align-items:flex-start}",
    ".bks-kd__media{flex:0 0 58px;width:58px}",
    ".bks-kd__img{width:58px;height:58px;border-radius:9px}",
    ".bks-kd__off{top:-7px;left:-7px;font-size:10px;padding:3px 6px}",
    ".bks-kd__tag{font-size:9.5px;padding:2px 7px}",
    ".bks-kd__t{font-size:13.5px}",
    ".bks-kd__p{font-size:11.5px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}",
    ".bks-kd__unlock{font-size:11px;padding:5px 9px;margin-top:3px}",
    ".bks-kd__row{gap:9px;margin-top:6px}",
    ".bks-kd__prices{flex:0 1 auto}",
    ".bks-kd__price{font-size:18px}",
    ".bks-kd__old{font-size:12.5px}",
    ".bks-kd__eco{font-size:10px;padding:2px 6px}",
    ".bks-kd__btn{flex:1 1 auto;padding:10px 12px;font-size:12px}",
    ".bks-kd__x{top:6px;right:7px;font-size:18px}",
    ".bks-kd__moto{margin-top:7px;padding-top:7px}",
    "}"
  ].join("");

  function styles() {
    if (document.getElementById("bks-kd-css")) return;
    var s = document.createElement("style");
    s.id = "bks-kd-css"; s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* --- Selecteur MARQUE puis MODELE, en bandes defilantes -----------------------------
     Purement additif : il ne touche NI a la detection de couleur, NI a la resolution du
     kit assorti, NI a la vignette. Bande 1 = marques ; au clic, la bande 2 se remplit
     avec les modeles de cette marque.
     Retourne { el, valeur } ; valeur() rend "Derbi Senda DRD", "Derbi" (marque seule)
     ou "" si le client n'a rien choisi — l'ajout au panier reste possible dans tous les cas. */
  function selecteurMoto() {
    var marqueChoisie = "", modeleChoisi = "", anneeChoisie = "";
    zoneAutre();   /* 02/10 : zone d'annonce présente avant tout refus */
    var SP_FACULTATIF = "— facultatif, on le note sur ta commande", SP_AUTRE = "— précise le modèle et l’année ci-dessous";

    var wrap = document.createElement("div");
    wrap.className = "bks-kd__moto";
    wrap.setAttribute("data-bks-kd-moto", "1");

    var lbl = document.createElement("p");
    lbl.className = "bks-kd__moto-lbl";
    lbl.appendChild(document.createTextNode("Ta moto "));
    var sp = document.createElement("span");
    sp.textContent = "— facultatif, on le note sur ta commande";
    lbl.appendChild(sp);

    var bandeM = document.createElement("div");
    bandeM.className = "bks-kd__band bks-kd__band--todo";
    bandeM.setAttribute("role", "group");
    bandeM.setAttribute("aria-label", "Choisis la marque de ta moto");

    var bandeMod = document.createElement("div");
    bandeMod.className = "bks-kd__band bks-kd__band--mod";
    bandeMod.setAttribute("role", "group");
    bandeMod.setAttribute("aria-label", "Choisis le modèle de ta moto");
    bandeMod.hidden = true;

    var bandeAn = document.createElement("div");
    bandeAn.className = "bks-kd__band bks-kd__band--year";
    bandeAn.setAttribute("role", "group");
    bandeAn.setAttribute("aria-label", "Choisis l'année de ta moto");
    bandeAn.hidden = true;

    var recap = document.createElement("p");
    recap.className = "bks-kd__moto-pick";
    recap.setAttribute("aria-live", "polite");
    recap.hidden = true;

    /* v2 (lot fusion-autre) : « Autre modèle » -> deux champs OBLIGATOIRES, à la place de la bande des années */
    SEQ_AUTRE++;
    var uid = "bks-kd-am-" + SEQ_AUTRE, autreTexte = "", autreAnnee = "", autreTente = false;
    var autreBox = document.createElement("div");
    autreBox.className = "bks-kd__autre"; autreBox.hidden = true;
    autreBox.setAttribute("role", "group"); autreBox.setAttribute("aria-labelledby", uid + "-t");
    var ans = '<option value="">Choisis l’année…</option>';
    for (var yy = BKS_REGLE.AN_MAX; yy >= BKS_REGLE.AN_MIN; yy--) ans += '<option value="' + yy + '">' + yy + "</option>";
    autreBox.innerHTML = '<p class="bks-kd__autre-t" id="' + uid + '-t">Précise ta moto <span class="bks-kd__autre-req">obligatoire</span></p>'
      + '<label class="bks-kd__autre-l" for="' + uid + '-m">Modèle exact</label>'
      + '<input class="bks-kd__autre-c" type="text" id="' + uid + '-m" maxlength="60" autocomplete="off" autocapitalize="words" spellcheck="false" placeholder="Le modèle, tel qu’écrit sur ta moto" aria-required="true" aria-describedby="' + uid + '-e">'
      /* 02/10 (v4) : la case de confirmation d'un modèle qu'on ne connaît pas (raison 'douteux') — cachée sinon */
      + '<div class="bks-kd__conf" id="' + uid + '-cf" hidden><input type="checkbox" id="' + uid + '-c" aria-describedby="' + uid + '-e"><label for="' + uid + '-c" id="' + uid + '-cl"></label></div>'
      + '<label class="bks-kd__autre-l" for="' + uid + '-a">Année</label>'
      + '<select class="bks-kd__autre-c" id="' + uid + '-a" aria-required="true" aria-describedby="' + uid + '-e">' + ans + "</select>"
      + '<p class="bks-kd__autre-e" id="' + uid + '-e"></p>';
    var champM = autreBox.querySelector("#" + uid + "-m"), champA = autreBox.querySelector("#" + uid + "-a"), champE = autreBox.querySelector("#" + uid + "-e");
    function estAutre() { return modeleChoisi === MOTO_AUTRE; }
    /* la marque est déjà choisie (puce) : on juge « marque + texte tapé » avec la règle commune */
    function autreRaison() { return BKS_REGLE.raison(marqueChoisie + " " + autreTexte); }
    /* 02/10 (v4, vérificateur fonction : « Derbi » + « jsaispas » serait passé) : une marque + seulement un mot inconnu
       donne 'douteux' — accepté SEULEMENT si la case « Oui, « … » est bien le nom exact de ma moto » est cochée pour CE
       texte (autreConf = le texte confirmé, il tombe si la saisie change) ; la commande le dit à l'atelier. */
    var ligneC = autreBox.querySelector("#" + uid + "-cf"), caseC = autreBox.querySelector("#" + uid + "-c"), libC = autreBox.querySelector("#" + uid + "-cl");
    var autreConf = "", autreVu = false;
    function autreDouteux() { return autreRaison() === "douteux"; }
    function autreConfOk() { return !!autreConf && autreConf === autreTexte.trim(); }
    function autreModOk() { var r = autreRaison(); return !r || (r === "douteux" && autreConfOk()); }
    function autreOk() { return autreModOk() && BKS_REGLE.anOk(autreAnnee); }
    function autreMessage() {
      var r = autreRaison(), y = BKS_REGLE.anOk(autreAnnee), puis = y ? "." : ", puis choisis l’année.";
      if (r === "douteux" && !autreConfOk()) return "On ne connaît pas ce modèle de " + marqueChoisie + " : si c’est bien son nom exact, coche la case ; sinon écris le modèle exact" + puis;
      /* 05/10 (règle v5) : la saisie hésite (« je crois », « ou », « ? »…) */
      if (r === "hesite") return "Écris un seul modèle de ta " + marqueChoisie + ", sans « je crois » ni « ou » : regarde ta carte grise, case D.3" + puis;
      if (r && r !== "douteux") return "Écris le modèle exact de ta " + marqueChoisie + puis;   /* pas d’exemple : un modèle d’une autre marque égarerait */
      if (!y) return "Choisis l’année de ta moto.";
      return "";
    }
    function autreEtat() {
      if (!autreConfOk()) autreConf = "";   /* la confirmation valait pour un autre texte */
      var dt = autreDouteux(), c = autreConfOk();
      var m = autreModOk(), y = BKS_REGLE.anOk(autreAnnee), msg = autreMessage();
      /* un modèle 'douteux' non confirmé : c'est la CASE qui est en faute, pas le texte */
      var mBad = autreTente && !m && !dt, cBad = autreTente && dt && !c;
      ligneC.hidden = !(dt && (autreVu || autreTente || c));
      caseC.checked = dt && c;
      var lt = "Oui, « " + (marqueChoisie + " " + autreTexte.trim()).trim() + " » est bien le nom exact de ma moto";
      if (libC.textContent !== lt) libC.textContent = lt;
      ligneC.classList.toggle("is-bad", cBad);
      caseC.setAttribute("aria-invalid", cBad ? "true" : "false");
      champM.classList.toggle("is-bad", mBad); champA.classList.toggle("is-bad", autreTente && !y);
      champM.setAttribute("aria-invalid", mBad ? "true" : "false");
      champA.setAttribute("aria-invalid", autreTente && !y ? "true" : "false");
      if (msg && autreTente) { champE.className = "bks-kd__autre-e on"; champE.textContent = msg + " Sans ça, on ne sait pas quel kit découper."; }
      else if (!msg) {
        champE.className = "bks-kd__autre-e ok"; champE.textContent = "C’est noté : l’atelier lira ta saisie telle quelle sur ta commande. Vérifie l’orthographe.";
        /* 02/10 (vérificateur rendu/a11y) : l'ancien refus restait dans la zone d'annonce (invisible) ; on la vide */
        var za = document.getElementById("bks-kd-annonce"); if (za && za.textContent) za.textContent = "";
      }
      else { champE.className = "bks-kd__autre-e"; champE.textContent = ""; }
    }
    var dejaValide = false;
    champM.addEventListener("input", function () {
      autreTexte = champM.value.slice(0, 60); autreVu = false; autreEtat(); memoriser();   /* 02/10 : on retape -> la case attend qu'on quitte le champ */
      /* le récap est une zone « polie » : on ne le réécrit JAMAIS à la frappe (il reparlerait à chaque lettre). Il est
         remis à jour quand le champ est quitté (« change » : un seul message), donc avant tout clic sur « Ajouter ». */
    });
    /* 02/10 : la case n'apparaît qu'en QUITTANT le champ (ou au refus) : pas d'apparition / disparition à chaque lettre */
    champM.addEventListener("change", function () { autreVu = true; autreEtat(); dejaValide = autreOk(); majRecap(); });
    caseC.addEventListener("change", function () { autreConf = caseC.checked ? autreTexte.trim() : ""; autreEtat(); memoriser(); dejaValide = autreOk(); majRecap(); });
    champA.addEventListener("change", function () { autreAnnee = champA.value; autreEtat(); memoriser(); dejaValide = autreOk(); majRecap(); });
    champM.addEventListener("keydown", function (ev) { if (ev.key === "Enter") { ev.preventDefault(); autreVu = true; autreEtat(); (autreDouteux() && !autreConfOk() ? caseC : champA).focus(); } });
    /* appelé par le bouton « Ajouter à ma commande » : true = ajout refusé (message, focus, annonce) */
    function bloque() {
      if (!estAutre() || autreOk()) return false;
      autreTente = true; autreEtat();
      /* 02/10 : la CASE s'il ne manque que la confirmation d'un modèle 'douteux' */
      var cible = autreModOk() ? champA : (autreDouteux() ? caseC : champM);
      try { autreBox.scrollIntoView({ block: "nearest", behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }); } catch (e) {}
      try { cible.focus({ preventScroll: true }); } catch (e) { cible.focus(); }
      annonceAutre(autreMessage() + " Sans ça, on ne sait pas quel kit découper.");
      return true;
    }

    function valeur() {
      if (!marqueChoisie) return "";
      if (!modeleChoisi) return marqueChoisie;
      /* v2 : « Autre modèle » n'est envoyé qu'avec le modèle tapé et l'année (bloque() garantit qu'ils sont valides) */
      /* 02/10 : un modèle hors de notre liste confirmé par la case le dit à l'atelier */
      if (estAutre()) return autreOk() ? (marqueChoisie + " " + autreTexte.trim() + " (" + autreAnnee + ") · autre modèle" + (autreDouteux() ? " · hors liste, confirmé par le client" : "")) : (marqueChoisie + " — autre modèle");
      var base = marqueChoisie + " " + modeleChoisi;
      if (anneeChoisie) base += " (" + anneeChoisie + ")";
      return base;
    }

    /* 02/10 (vérificateur rendu/a11y) : « Ta moto — facultatif » s'affichait juste au-dessus de « Précise ta moto
       OBLIGATOIRE » quand « Autre modèle » est choisi : deux mentions contraires sous les yeux du client. */
    function majRecap() {
      var spT = estAutre() ? SP_AUTRE : SP_FACULTATIF;
      if (sp.textContent !== spT) sp.textContent = spT;
      sp.classList.toggle("is-requis", estAutre());   /* 02/10 : la consigne en violet gras (7,10:1), plus en gris */
      if (!marqueChoisie) { recap.hidden = true; recap.textContent = ""; return; }
      recap.hidden = false;
      if (!modeleChoisi) { recap.textContent = "Moto : " + marqueChoisie + " — choisis ton modèle"; return; }
      if (estAutre()) { recap.textContent = autreOk() ? "Moto : " + valeur() : "Moto : " + marqueChoisie + " — autre modèle : précise le modèle et l’année"; return; }
      if (!anneeChoisie) { recap.textContent = "Moto : " + valeur() + " — choisis l'année"; return; }
      recap.textContent = "Moto : " + valeur();
    }

    /* Le panier se rafraichit souvent (quantite, cadeaux, sync) et la carte est alors
       reconstruite : sans memoire, le client perdrait son choix en cours de route.
       On le garde le temps de la session, comme l'opt-out de la carte. */
    function memoriser() {
      ssSet(MOTO_KEY, JSON.stringify({ m: marqueChoisie, x: modeleChoisi, a: anneeChoisie, t: autreTexte, y: autreAnnee, c: autreConf }));
    }

    /* Une puce = un vrai <button> : focusable, actionnable au clavier, etat expose
       via aria-pressed (et pas seulement par la couleur). */
    function puce(texte, bande, auClic) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "bks-kd__chip";
      b.setAttribute("aria-pressed", "false");
      b.textContent = texte;
      b.addEventListener("click", function () {
        Array.prototype.slice.call(bande.querySelectorAll(".bks-kd__chip")).forEach(function (o) {
          o.classList.remove("is-on");
          o.setAttribute("aria-pressed", "false");
        });
        b.classList.add("is-on");
        b.setAttribute("aria-pressed", "true");
        // recentrer la puce choisie dans sa bande, sans faire defiler la page
        try { b.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" }); } catch (e) {}
        auClic(texte);
      });
      bande.appendChild(b);
      return b;
    }

    /* Fleches gauche/droite : la navigation clavier suit l'ordre visuel de la bande. */
    function clavier(bande) {
      bande.addEventListener("keydown", function (ev) {
        if (ev.key !== "ArrowRight" && ev.key !== "ArrowLeft") return;
        var puces = Array.prototype.slice.call(bande.querySelectorAll(".bks-kd__chip"));
        var i = puces.indexOf(document.activeElement);
        if (i < 0) return;
        var j = i + (ev.key === "ArrowRight" ? 1 : -1);
        if (j < 0 || j >= puces.length) return;
        ev.preventDefault();
        puces[j].focus();
      });
    }
    clavier(bandeM); clavier(bandeMod); clavier(bandeAn);

    /* Bande ANNEE : proposee des qu'un modele est choisi. Les annees ne sont PAS
       specifiques au modele (BKS n'a pas cette donnee, on n'invente rien) : liste
       d'annees reelles, generee dynamiquement, + un repli "2003 et avant". Le but est
       d'inscrire l'annee sur la commande pour identifier le bon kit. */
    function anneesDispo() {
      var out = [], y;
      try { y = new Date().getFullYear(); } catch (e) { y = 2026; }
      if (!(y >= 2005 && y <= 2100)) y = 2026;
      for (var a = y; a >= 2004; a--) out.push(String(a));
      out.push("2003 et avant");
      return out;
    }
    function remplirAnnees() {
      bandeAn.textContent = "";
      anneesDispo().forEach(function (an) {
        puce(an, bandeAn, function (v) { anneeChoisie = v; majRecap(); memoriser(); });
      });
      bandeAn.hidden = false;
      try { bandeAn.scrollLeft = 0; } catch (e) {}
    }

    function remplirModeles(marque) {
      bandeMod.textContent = "";
      var entree = null;
      for (var i = 0; i < MOTOS.length; i++) {
        if (MOTOS[i].marque === marque) { entree = MOTOS[i]; break; }
      }
      var liste = (entree ? entree.modeles : []).concat([MOTO_AUTRE]);
      liste.forEach(function (m) {
        puce(m, bandeMod, function (v) {
          modeleChoisi = v; anneeChoisie = "";
          /* v2 : « Autre modèle » -> les deux champs obligatoires ; un modèle de la liste -> la bande des années */
          if (v === MOTO_AUTRE) { bandeAn.hidden = true; bandeAn.textContent = ""; autreBox.hidden = false; autreTente = false; autreEtat(); dejaValide = autreOk(); }
          else { autreBox.hidden = true; remplirAnnees(); }
          majRecap(); memoriser();
        });
      });
      bandeMod.hidden = false;
      try { bandeMod.scrollLeft = 0; } catch (e) {}
    }

    MOTOS.forEach(function (e) {
      puce(e.marque, bandeM, function (v) {
        if (v === marqueChoisie) return;
        marqueChoisie = v;
        modeleChoisi = "";
        autreConf = "";   /* 02/10 : une confirmation valait pour « marque + texte » : autre marque, plus de confirmation */
        anneeChoisie = "";
        bandeAn.hidden = true; bandeAn.textContent = "";
        autreBox.hidden = true;
        bandeM.classList.remove("bks-kd__band--todo");
        remplirModeles(v);
        majRecap();
        memoriser();
      });
    });

    /* Rejoue le choix memorise en cliquant les puces : un seul chemin de code, donc
       aucun risque de divergence entre l'etat visuel et la valeur envoyee au panier.
       wrap n'est pas encore dans le document ici : les scrollIntoView sont sans effet. */
    (function restaurer() {
      var brut = ss(MOTO_KEY);
      var v = null;
      if (brut) { try { v = JSON.parse(brut); } catch (e) { v = null; } }
      /* Rien en session : on retombe sur la moto deja saisie au panier (le client
         ne ressaisit pas ce qu'il a deja donne). */
      if (!v || !v.m) v = MOTO_PANIER;
      if (!v || !v.m) return;
      var pm = null, pms = bandeM.querySelectorAll(".bks-kd__chip");
      for (var i = 0; i < pms.length; i++) { if (pms[i].textContent === v.m) { pm = pms[i]; break; } }
      if (!pm) return;
      pm.click();                                   // remplit aussi la bande des modeles
      if (!v.x) return;
      var pmods = bandeMod.querySelectorAll(".bks-kd__chip");
      for (var j = 0; j < pmods.length; j++) {
        if (pmods[j].textContent === v.x) {
          if (v.x === MOTO_AUTRE) { autreTexte = String(v.t || "").slice(0, 60); autreAnnee = String(v.y || "").slice(0, 4); autreConf = String(v.c || "").slice(0, 60); champM.value = autreTexte; champA.value = autreAnnee; }
          pmods[j].click();
          if (v.a) {
            var pans = bandeAn.querySelectorAll(".bks-kd__chip");
            for (var k = 0; k < pans.length; k++) { if (pans[k].textContent === v.a) { pans[k].click(); break; } }
          }
          return;
        }
      }
    })();

    wrap.appendChild(lbl);
    wrap.appendChild(bandeM);
    wrap.appendChild(bandeMod);
    wrap.appendChild(bandeAn);
    wrap.appendChild(autreBox);
    wrap.appendChild(recap);
    return { el: wrap, valeur: valeur, bloque: bloque };
  }

  function construire(offre) {
    var p = offre.produit;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    var couleurAff = offre.couleur.charAt(0).toUpperCase() + offre.couleur.slice(1);

    var box = document.createElement("div");
    box.className = "bks-kd" + (offre.remise ? " bks-kd--promo" : "");
    box.setAttribute("data-bks-kd", "1");

    // pastille de remise, posee sur la vignette : c'est le premier element que l'oeil accroche
    var media = document.createElement("div"); media.className = "bks-kd__media";
    if (offre.remise) {
      var pastille = document.createElement("span");
      pastille.className = "bks-kd__off";
      pastille.textContent = "−10 %";
      media.appendChild(pastille);
    }

    var img = document.createElement("img");
    img.className = "bks-kd__img";
    // PAS de loading="lazy" : sur une image inseree dynamiquement apres le chargement de la page,
    // le navigateur ne declenche pas toujours le chargement differe et la vignette reste vide
    // (constate en test reel). Une vignette de 200 px ne justifie pas ce risque.
    img.decoding = "async";
    img.width = 200; img.height = 200;
    img.alt = p.title || "Kit déco BKS";
    img.src = vignette(p.featured_image);

    var body = document.createElement("div"); body.className = "bks-kd__body";
    var tag = document.createElement("span"); tag.className = "bks-kd__tag";
    var t = document.createElement("p"); t.className = "bks-kd__t";
    var d = document.createElement("p"); d.className = "bks-kd__p";

    if (offre.type === "exact") {
      tag.textContent = "Assorti à ta selle";
      t.textContent = "Complète ta selle avec le kit déco " + couleurAff;
      d.textContent = "Le kit déco " + couleurAff + " reprend exactement la couleur de ta housse : ta 50 est raccord, "
                    + "de la selle aux carénages.";
    } else if (offre.type === "accorde") {
      tag.textContent = "Accordé à ta selle " + couleurAff;
      t.textContent = "Complète ta selle avec le kit déco";
      d.textContent = p.title + " — le " + couleurAff.toLowerCase() + " de ta housse s'y retrouve. "
                    + "Pose à froid, en quelques minutes.";
    } else {
      // repli : aucune promesse d'assortiment, c'est une piece deco a part entiere
      tag.textContent = "Petit plus déco";
      t.textContent = "Ajoute le kit déco carter";
      d.textContent = "La pièce déco la plus prise par les clients BKS. "
                    + "Le kit déco complet n'existe pas encore en " + couleurAff.toLowerCase() + ".";
    }

    /* Selecteur marque + modele. Construit ICI pour etre disponible dans le gestionnaire
       de clic ci-dessous ; il est insere plus bas, juste avant la ligne prix + bouton. */
    var moto = selecteurMoto();

    var row = document.createElement("div"); row.className = "bks-kd__row";
    var zonePrix = document.createElement("div"); zonePrix.className = "bks-kd__prices";

    if (offre.remise) {
      // -10 % reellement applique par Shopify (reduction automatique liee a la selle du panier)
      var remise = Math.round(v.price * (1 - REMISE));
      var barre = document.createElement("span"); barre.className = "bks-kd__old";
      barre.textContent = euro(v.price);
      var neuf = document.createElement("span"); neuf.className = "bks-kd__price";
      neuf.textContent = euro(remise);
      var eco = document.createElement("span"); eco.className = "bks-kd__eco";
      eco.textContent = "tu économises " + euro(v.price - remise);
      zonePrix.appendChild(barre); zonePrix.appendChild(neuf); zonePrix.appendChild(eco);
    } else {
      var seul = document.createElement("span"); seul.className = "bks-kd__price";
      seul.textContent = euro(v.price);
      zonePrix.appendChild(seul);
    }

    var btn = document.createElement("button"); btn.type = "button"; btn.className = "bks-kd__btn";
    btn.textContent = "Ajouter à ma commande";

    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      /* v2 : « Autre modèle » choisi sans modèle exact ni année valides -> on n'ajoute pas, on dit quoi faire */
      if (moto.bloque && moto.bloque()) return;
      btn.disabled = true; btn.textContent = "Ajout…";
      /* Non bloquant : si rien n'a ete choisi, moto.valeur() rend "" et l'ajout se fait
         quand meme, simplement sans la propriete "Moto". */
      ajouter(v.id, offre.couleur, offre.type, moto.valeur()).then(function () {
        btn.textContent = "Ajouté ✓";
        setTimeout(function () { try { box.remove(); } catch (e) {} }, 900);
      }).catch(function () {
        btn.disabled = false; btn.textContent = "Ajouter à ma commande";
      });
    });

    var x = document.createElement("button");
    x.type = "button"; x.className = "bks-kd__x"; x.setAttribute("aria-label", "Masquer cette suggestion");
    x.innerHTML = "&times;";
    x.addEventListener("click", function () { ssSet(OPTOUT, "1"); try { box.remove(); } catch (e) {} });

    row.appendChild(zonePrix); row.appendChild(btn);
    body.appendChild(tag); body.appendChild(t); body.appendChild(d);

    /* L'argument central : ce n'est pas une promo generique, c'est SA selle qui debloque la remise.
       On ne l'affiche que si la remise s'appliquera vraiment (selle eligible + produit remisable). */
    if (offre.remise) {
      var deblo = document.createElement("p");
      deblo.className = "bks-kd__unlock";
      deblo.innerHTML = "<b>−10 % débloqué</b> par la selle dans ton panier — déjà déduit ci-dessous.";
      body.appendChild(deblo);
    }
    body.appendChild(moto.el);
    body.appendChild(row);
    media.appendChild(img);
    box.appendChild(media); box.appendChild(body); box.appendChild(x);
    return box;
  }

  /* Emplacements : page panier (sous la barre de progression) et tiroir panier.
     ATTENTION : la barre de progression n'a PAS la classe "bks-shipping-bar" (c'est le nom du
     snippet Liquid, pas celui du noeud rendu). Le noeud reel porte la classe "bks-bar3" et
     l'attribut data-bks-ship3 — c'est lui qu'il faut viser dans le tiroir. Sur la page panier,
     main-cart.liquid enveloppe le rendu dans .bks-cart-page-bar, qu'on utilise directement. */
  function ancres() {
    var out = [];
    var page = document.querySelector(".bks-cart-page-bar");
    if (page && page.parentNode) out.push({ noeud: page, mode: "apres" });
    var tiroirs = document.querySelectorAll("cart-drawer, .cart-drawer, #cart-drawer");
    var mobile = false;
    try { mobile = window.matchMedia("(max-width:560px)").matches; } catch (e) {}
    Array.prototype.slice.call(tiroirs).forEach(function (t) {
      var barre = t.querySelector("[data-bks-ship3], .bks-bar3");
      var pied = t.querySelector(".cart-drawer__footer");
      // Mobile (retour Micka 31/08) : encart place TOUT EN BAS, juste avant le pied
      // (bouton commande), pour laisser voir les articles du panier en premier.
      // Desktop : sous la barre cadeau, comme avant (l'espace ne manque pas).
      if (mobile && pied && pied.parentNode) { out.push({ noeud: pied, mode: "avant" }); return; }
      if (barre && barre.parentNode) { out.push({ noeud: barre, mode: "apres" }); return; }
      if (pied && pied.parentNode) out.push({ noeud: pied, mode: "avant" });
    });
    if (!out.length) {
      var repli = document.querySelector("form.cart-page, .cart-drawer__footer, cart-drawer form");
      if (repli) out.push({ noeud: repli, mode: "avant" });
    }
    return out;
  }

  function nettoyer() {
    Array.prototype.slice.call(document.querySelectorAll("[data-bks-kd]")).forEach(function (n) {
      try { n.remove(); } catch (e) {}
    });
  }

  function rendre() {
    if (BUSY) return; BUSY = true;
    if (ss(OPTOUT) === "1") { BUSY = false; return; }
    getCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) { nettoyer(); BUSY = false; return; }
      if (dejaAuPanier(cart)) { nettoyer(); BUSY = false; return; }
      MOTO_PANIER = motoDepuisPanier(cart);
      var couleur = couleurSelle(cart);
      if (!couleur) { nettoyer(); BUSY = false; return; }
      return kitAssorti(couleur).then(function (offre) {
        nettoyer();
        if (!offre) { BUSY = false; return; }          // aucune fausse offre
        var cibles = ancres();
        if (!cibles.length) { BUSY = false; return; }
        // On n'annonce le -10 % que s'il s'appliquera VRAIMENT : selle eligible au panier
        // ET produit propose appartenant a une collection remisee. Sinon, prix normal seul.
        return selleEligible(cart).then(function (eligible) {
          var remisable = estRemise(offre.produit);
          offre.remise = !!(eligible && remisable);
          // trace de diagnostic : permet de comprendre en une ligne pourquoi l'offre est
          // affichee avec ou sans remise, sans avoir a instrumenter le fichier a chaud.
          try {
            window.__bksKitDecoDebug = {
              selleEligible: eligible, produitRemisable: remisable, remiseAffichee: offre.remise,
              type: offre.type, handle: (offre.produit || {}).handle,
              tags: (offre.produit || {}).tags
            };
          } catch (e) {}
          poser(offre, cibles);
        });
      });
    }).catch(function () { BUSY = false; });
  }

  function poser(offre, cibles) {
    try {
      styles();
      cibles.forEach(function (a) {
        var el = construire(offre);
        if (!el) return;
        if (a.mode === "apres") a.noeud.parentNode.insertBefore(el, a.noeud.nextSibling);
        else a.noeud.parentNode.insertBefore(el, a.noeud);
      });
    } catch (e) {}
    BUSY = false;
  }

  function planifier() { if (TMR) clearTimeout(TMR); TMR = setTimeout(rendre, 350); }

  /* Le panier bouge (ajout, retrait, quantite, cadeaux) -> on re-evalue l'offre. */
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  try {
    var of = window.fetch;
    if (typeof of === "function") {
      window.fetch = function (input) {
        var url = "";
        try { url = (typeof input === "string") ? input : (input && input.url) || ""; } catch (e) {}
        return of.apply(this, arguments).then(function (res) {
          if (RX.test(url)) planifier();
          return res;
        });
      };
    }
  } catch (e) {}
  ["cart:updated", "cart:refresh", "cart:change", "bks:gift-sync"].forEach(function (ev) {
    document.addEventListener(ev, planifier);
  });
  window.addEventListener("pageshow", planifier);
  // Rotation / redimensionnement qui franchit le point de rupture mobile <-> desktop :
  // on re-evalue pour replacer l'encart au bon endroit (bas sur mobile, haut sur desktop).
  try {
    var _mqKd = window.matchMedia("(max-width:560px)");
    if (_mqKd.addEventListener) _mqKd.addEventListener("change", planifier);
    else if (_mqKd.addListener) _mqKd.addListener(planifier);
  } catch (e) {}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", planifier);
  else planifier();

  window.__bksKitDecoRun = rendre;   // utile pour les tests
})();
